export default {
  psw: "Mật khẩu",
  topFive: "5 đầu tiên",
  confPsw: "Xác nhận Mật khẩu",
  newPsw: "Mật khẩu mới",
  email: "thư điện tử ",
  emailId: "mã thư điện tử ",
  submit: "Gửi",
  cancel: "Hủy",
  faqs: "Câu hỏi thường gặp",
  id: "nhận dạng",
  january: "Tháng Một",
  february: "Tháng Hai",
  march: "Tháng Ba",
  april: "Tháng Tư",
  june: "Tháng Sáu",
  july: "Tháng Bảy",
  august: "Tháng Tám",
  september: "Tháng Chín",
  october: "Tháng Mười",
  november: "Tháng Mười Một",
  december: "Tháng Mười Hai",
  jan: "tháng một",
  feb: "tháng hai",
  mar: "tháng ba",
  apr: "tháng tư",
  may: "có thể",
  jun: "tháng sáu",
  jul: "tháng bảy",
  aug: "tháng tám",
  sep: "tháng chín",
  oct: "tháng mười",
  nov: "tháng mười một",
  dec: "tháng mười hai",
  totalFarmerLand: "Tổng diện tích Nông dân",
  of: "của",
  'Select': "Chọn",
  'Enter here': "Nhập vào đây",
  "Farmer Name": "Tên Nông dân",
  "parchmentId": "ID vỏ trấu",
  processor: "Bộ xử lý",
  cuppingScore: "Điểm Cupping",
  label: "Nhãn",
  expiry: "Hết hạn",
  users: "Người dùng",
  language: "Ngôn ngữ",
  appUser: "Người dùng ứng dụng",
  app_users: "Người dùng ứng dụng",
  offline_users: "Người dùng ngoại tuyến",
  dimitraAdmin: "Quản trị viên Dimitra",
  admin_users: "Người dùng quản trị viên",
  search: "Tìm kiếm",
  searchBy: "Tìm kiếm theo {type}",
  firstName: "Tên",
  lastName: "Họ",
  mobile: "Di động",
  mobileNumber: "Số điện thoại di động",
  department: "Bộ phận",
  role: "Vai trò",
  status: "Trạng thái",
  permission: "Quyền",
  activity_log: "Nhật ký hoạt động",
  profile_auth: "Xác thực hồ sơ",
  countryCode: "Mã quốc gia",
  selectDept: "Chọn Bộ phận",
  selectRole: "Chọn Vai trò",
  edit: "Chỉnh sửa",
  update: "Cập nhật",
  delete: "Xóa",
  view: "Xem",
  deactivate: "Ngưng hoạt động",
  activate: "Kích hoạt",
  serverError: "Đã xảy ra lỗi. Vui lòng thử lại sau.",
  minute: "Phút",
  perHour: "Mỗi giờ",
  day: "Ngày",
  enterDescription: "Nhập mô tả của bạn ở đây",
  enterHere: "Nhập vào đây",
  enterMobile: "Nhập số điện thoại di động",
  phoneRequired: "Yêu cầu điện thoại",
  phoneValid: "Điện thoại phải hợp lệ",
  unableToUpdate: "Không thể cập nhật",
  membershipPlans: "Kế hoạch thành viên",
  byWeek: "Theo tuần",
  byMonth: "Theo tháng",
  byYear: "Theo năm",
  custom: "Tùy chỉnh",
  name: "Tên",
  warehouse: "Nhà kho",
  regionState: "Khu vực/Quận",
  provinceState: "Tỉnh/Quận",
  cityTown: "Làng/Thị trấn/Thị trấn",
  membershipValidity: "Hiệu suất cơ sở thành viên",
  extendedValidity: "Hiệu suất được mở rộng",
  exportAsCSV: "Xuất ra dạng CSV",
  filterBy: "Lọc theo",
  autoCondition: "Điều kiện tự động",
  conditional: "Điều kiện",
  comingSoon: "Sắp có",
  userRole: "Vai trò người dùng",
  additionalInformationRequired: "Yêu cầu Thông tin bổ sung",
  back: "Trở lại",
  browse: "Duyệt",
  clearAll: "XÓA TẤT CẢ",
  continue: "Tiếp tục",
  description: "Miêu tả",
  selectWeek: "Chọn Tuần",
  confirm: "XÁC NHẬN",
  selectMonth: "Chọn Tháng",
  selectDateRange: "Chọn Phạm vi ngày",
  regionDistrict: "Khu vực/Quận",
  address: "Địa chỉ",
  familyTribe: "Bộ tộc gia đình",
  website: "Trang web",
  deactivated: "Đã ngưng hoạt động",
  active: "Hoạt động",
  Inactive: "Không hoạt động",
  'Download Survey List': "Tải xuống danh sách khảo sát",
  country: "Quốc gia",
  farmer: "Nông dân",
  commodity: "Hàng hóa",
  quantity: "Số lượng",
  unit: "Đơn vị",
  price: "Giá",
  save: "LƯU",
  stateIsReq: "Yêu cầu quốc gia",
  cityIsReq: "Yêu cầu thành phố",
  addressIsReq: "Yêu cầu địa chỉ",
  membershipTypeReq: "Loại thành viên là bắt buộc",
  extendedReasonReq: "Lý do mở rộng là bắt buộc",
  numberOfDaysReq: "Số ngày là bắt buộc",
  extendedMembershipValidity: "Hiệu suất thành viên được mở rộng",
  set: "ĐẶT",
  adminRole: "Vai trò quản trị viên",
  typeMsg: "Nhập tin nhắn của bạn ở đây",
  manageFarmer: "Quản lý Nông dân",
  manageOfflineFarmers: "Quản lý Nông dân Ngoại tuyến",
  dashboardSettings: "Cài đặt Bảng điều khiển",
  done: "Xong",
  noRecordFound: "Không tìm thấy bản ghi",
  farmerName: "Tên Nông dân",
  production: "Sản xuất",
  registered: "Đã đăng ký",
  downloadForReport: "TẢI XUỐNG BÁO CÁO PDF",
  downloadPdfReport: "Tải báo cáo PDF",
  notifications: "Thông báo",
  markAllAsRead: "Đánh dấu tất cả là đã đọc",
  viewNotifications: "Xem Thông báo",
  youAreUpToDate: "Bạn đã cập nhật",
  sendNotifications: "Gửi Thông báo",
  createNotification: "Tạo Thông báo",
  viewAllNotifications: "Xem tất cả Thông báo",
  note: "*Lưu ý: Chỉ tệp Mp4 được hỗ trợ cho video",
  validMemberships: "Thành viên hợp lệ",
  memberShipPlanMessage: "Bạn có chắc muốn xóa kế hoạch thành viên này không?",
  deleteMemberShipPlan: "Xóa kế hoạch thành viên",
  systemAutoLogout: "Hệ thống sẽ tự động đăng xuất trong 2 phút",
  monday: "Thứ Hai",
  tuesday: "Thứ Ba",
  Wednesday: "Thứ Tư",
  wednesday: "Thứ Tư",
  thursday: "Thứ Năm",
  friday: "Thứ Sáu",
  saturday: "Thứ Bảy",
  sunday: "Chủ Nhật",
  warning: "Cảnh báo",
  addnewOfflineFarmer: "Thêm Nông dân ngoại tuyến mới",
  export: "Xuất khẩu",
  createNewOfflineFarmer: "Tạo Nông dân Ngoại tuyến mới",
  offlineFarmerForByingStationOnly:
    "Nông dân Ngoại tuyến chỉ dành cho trạm mua hàng (Địa phương)",
  offlineFarmerForAllByingStations:
    "Nông dân Ngoại tuyến cho tất cả các trạm mua hàng (Toàn cầu)",
  noDataAvailable: "Không có dữ liệu",
  buyingStation: "Trạm mua hàng",
  dryMillingStation: "Trạm xay khô",
  mergeWithExistingAccount: "Hợp nhất với tài khoản hiện tại",
  createNewAccount: "Tạo tài khoản mới",
  mobileOrEmailRequiredForRegister:
    "Để đăng ký ứng dụng, ít nhất một chi tiết phải được cung cấp, có thể là số điện thoại di động hoặc email.",
  selectLanguage: "Chọn ngôn ngữ",
  basicPlan: "Gói cơ bản",
  local: "Địa phương",
  newUser: "Người dùng mới",
  merged: "Đã hợp nhất",
  global: "Toàn cầu",
  qrcode: "Mã QR",
  userDashboard: "Bảng điều khiển người dùng",
  userByStatus: "Người dùng theo trạng thái",
  "Total Fresh Yield": "Tổng Năng suất Tươi",
    "Total Dry Yield": "Tổng Năng suất Khô",
    "Carbon": "Cacbon",
    "Nitrogen": "Nitơ",
    "Phosphorus": "Photpho",
    "Potassium": "Kali",
    "Calcium": "Canxi",
    "Magnesium": "Magie",
    "Sulphur": "Lưu huỳnh",
    "Sodium": "Natri",
  errors: {
    cannotBeBlank: "Trường này không thể trống",
    required: "Trường này là bắt buộc",
    somethingWentWrong: "Có lỗi xảy ra!!!",
    goBack: "Quay lại",

  },
  loadingData: "Đang tải dữ liệu...",
  markAsRead: "Đánh dấu là đã đọc",
  membership: {
    remainingDays: "Số Ngày Gia hạn",
    type: "Loại Hội viên",
    validity: "Hiệu suất Hội viên",
    validityLength: {
      custom: "Tùy chỉnh",
      expired: "Hết hạn",
      oneTo8Months: "1-8 tháng",
      lessThan1Month: "Dưới 1 tháng",
      moreThan1Month: "Hơn 1 năm",
      sixTo12Months: "6-12 tháng",
    },
  },
  
  ok: "Đồng ý",
  statusItems: {
    closed: "Đã đóng",
    open: "Mở",
  },
  orderByItems: {
    all: "Tất cả",
    dateAscending: "Ngày tăng dần",
    dateDescending: "Ngày giảm dần",
    dueDate: "Ngày đáo hạn",
    high: "Cao",
    low: "Thấp",
    medium: "Trung bình",
  },
  orderBy: "Sắp xếp theo",
  select: "Chọn",
  type: "Loại",
  uploadImageVideo: "Tải ảnh",
  user: "Người dùng",
  userName: "Tên người dùng",
  usersSelected: "Người dùng được chọn",
  topics: "Chủ đề",
  date: "Ngày",
  addNew: "THÊM MỚI",
  exportAsCsv: "Xuất ra CSV",
  noData: "Không có dữ liệu",
  login: {
    welcomeMsg: "Chào mừng! Đăng nhập",
    info: "Nhập thông tin đăng nhập của bạn.",
    forgot: "Quên mật khẩu?",
    btn: "Đăng nhập",
    unableToLogin: "Không thể đăng nhập",
  },
  forgot: {
    info_l1:
      "Vui lòng nhập địa chỉ email liên kết với tài khoản của bạn. Chi tiết mật khẩu sẽ được gửi đến địa chỉ email/số điện thoại di động của bạn.",
    info_l2:
      "Vui lòng nhập số điện thoại di động của bạn liên kết với tài khoản của bạn. Chi tiết mật khẩu sẽ được gửi đến số điện thoại.",
    info_l3:
      "Vui lòng chọn một trong những lựa chọn sau để nhận hướng dẫn về cách đặt lại mật khẩu của bạn.",
    forgotQ: "Quên mật khẩu của bạn?",
    loginNow: "Đăng nhập ngay",
    resetSucc: "Mật khẩu của bạn đã được đặt lại thành công",
    resetSucc_l2:
      "Bạn có thể sử dụng mật khẩu mới để đăng nhập vào tài khoản của mình ngay bây giờ.",
    entPsw: "Vui lòng nhập mật khẩu mới của bạn.",
    resetPsw: "Đặt lại mật khẩu của bạn",
    resendOTP: "Gửi lại OTP",
    enterCorrectOTP: "Vui lòng nhập đúng mã OTP.",
    enterOTP: "Vui lòng nhập OTP đã nhận qua email/số điện thoại di động.",
    backToLoginPage: "Quay lại trang đăng nhập",
    recieveCodeFalse: "Tôi không nhận được mã",
  },
  dashboard: "Bảng điều khiển",
  userslist: {
    createNewUser: "Tạo Người Dùng Mới",
    chooseCreateType: "Vui lòng chọn một trong những tùy chọn sau:",
    addNewUser: "Thêm Người Dùng Mới",
    editUser: "Chỉnh Sửa Người Dùng",
    addNewAdmin: "Thêm Người Dùng Quản Trị",
    userLoading: "Đang tải Người Dùng... Vui lòng đợi",
    noUser: "KHÔNG CÓ NGƯỜI DÙNG",
    extendVal: "GIA HẠN THỜI HẠN",
    extendReason: "Lý Do Gia Hạn",
    extendReasonMsg: "Chỉ định lý do gia hạn thành viên",
    exportAsCSV: "XUẤT RA CSV",
    membershipType: "Loại Thành Viên",
    membershipValidity: "Hiệu lực Thành Viên",
    regionState: "Vùng/Quận",
    cityTown: "Thị Trấn/Thành Phố",
    clearAll: "XÓA TẤT CẢ",
    search: "TÌM KIẾM",
    familyTribe: "Nhập bộ tộc gia đình của bạn",
    enterWebsite: "Nhập trang web",
    registrationDate: "Ngày Đăng Ký",
    single: "Độc thân",
    multiple: "Đa số",
    user: "Người Dùng",
  },
  addEdituser: {
    facilityPicture: "Hình Ảnh Cơ Sở",
    firstNameRequired: "Yêu cầu Họ là bắt buộc",
    firstNameOllyAlpha: "Họ chỉ có thể chứa chữ cái",
    firstNameLimit: "Họ phải ít hơn 30 ký tự",
    lastNameRequired: "Yêu cầu Tên là bắt buộc",
    lastNameOllyAlpha: "Tên chỉ có thể chứa chữ cái",
    lastNameLimit: "Tên phải ít hơn 30 ký tự",
    emailReuired: "Yêu cầu Email",
    emailInvalid: "Định dạng email không hợp lệ.",
    mobileRequired: "Yêu cầu số điện thoại di động",
    invalidMobile: "Định dạng số điện thoại di động không hợp lệ.",
    pswRequired: "Yêu cầu Mật khẩu",
    deptRequired: "Yêu cầu Bộ phận",
    roleRequired: "Yêu cầu Vai trò",
    countryRequired: "Yêu cầu Mã Quốc gia",
    userUpdated: "Người Dùng Đã Cập Nhật",
    userNotUpdated: "Không Thể Cập Nhật Người Dùng",
    activateAct: "Kích Hoạt Tài Khoản",
    deactivateAct: "Vô Hiệu Hóa Tài Khoản",
    userActivated: "Người Dùng Đã Kích Hoạt",
    userDeactivated: "Người Dùng Đã Vô Hiệu Hóa",
    deactivateUser: "Vô Hiệu Hóa Người Dùng",
    deactivateMsg: "Bạn có chắc muốn thay đổi trạng thái người dùng không.",
    userAdded: "Người Dùng Đã Thêm",
    userNotAdded: "Không Thể Thêm Người Dùng",
    editAppUser: "Chỉnh Sửa Người Dùng Ứng Dụng",
    validityUpTo: "Hiệu Lực Đến",
  },
  permissions: {
    savePermissions: "LƯU QUYỀN",
    moduleName: "Tên Mô-đun",
    view: "Xem",
    create: "Tạo",
    update: "Cập Nhật",
    delete: "Xóa",
    permissionsUpdated: "Quyền Đã Cập Nhật",
    permissionsNotUpdated: "Quyền Không Được Cập Nhật",
    selectMembership: "Chọn Thành Viên",
    noPermMsg:
      "Vui lòng chọn loại thành viên bằng cách sử dụng thanh thả xuống 'Loại Thành Viên' ở phía trên để xem quyền của bạn",
    selectRoleMsg: "Vui lòng chọn Vai trò ở phía trên để hiển thị quyền",
  },
  logs: {
    time: "Thời gian",
    username: "Tên người dùng",
    role: "Vai trò",
    terminalID: "ID thiết bị đầu cuối",
    moduleAccessed: "Module đã truy cập",
    typeOfAccess: "Loại truy cập",
    activityLogDetails: "Chi tiết nhật ký hoạt động",
    userId: "ID người dùng",
    lastLogin: "Đăng nhập lần cuối",
    geoAccPoint: "Điểm truy cập địa lý",
    ipAdd: "Địa chỉ IP",
    filesAccessed: "Các tệp đã truy cập",
    funAccessed: "Chức năng đã truy cập",
    webUrl: "URL trang web",
    unsuccAtmp: "Nỗ lực đăng nhập không thành công",
    view: "Xem",
    membershipType: "Loại thành viên"
  },
  profileSetting: {
    defaultOrganizationOTPForSignUp: "OTP tổ chức mặc định cho đăng ký",
    whoreceivedthealert: "Ai nhận cảnh báo",
    otp: "OTP",
    passwordReuse: "Sử dụng lại mật khẩu",
    organizationSplashScreen: "Màn hình chào mừng tổ chức",
    organizationSplash1: "Màn hình chào mừng tổ chức",
    generateOtp: "Tạo OTP",
    addAnother: "Thêm cái khác",
    dragAndDropOr: "Kéo & Thả hoặc Duyệt",
    browse: "Duyệt",
    save: "Lưu",

    profileAuthSettings: "Cài đặt xác thực hồ sơ",
    changeSettings: "THAY ĐỔI CÀI ĐẶT",
    loginLogoutSettings: "Cài đặt đăng nhập/đăng xuất",
    autoLogout: "Tự động đăng xuất",
    unsuccAtmp: "Nỗ lực đăng nhập không thành công",
    unsuccLoginLock: "Thời gian khóa đăng nhập không thành công",
    pswCrisetup: "Thiết lập tiêu chí mật khẩu",
    pswLength: "Độ dài mật khẩu",
    noOfUniquePsw: "Số lượng mật khẩu duy nhất yêu cầu",
    maxPswAge: "Tuổi thọ tối đa của mật khẩu",
    AccRangeOfchars: "Phạm vi ký tự chấp nhận",
    upperCase: "Chữ hoa",
    lowerCase: "Chữ thường",
    numbers: "Số",
    specialChars: "Ký tự đặc biệt",
    settingsUpdated: "Cài đặt đã được cập nhật",
    settingsNotUpdated: "Cài đặt chưa được cập nhật",
    organization: "Tổ chức",
    organizationLogo: "Logo tổ chức",
    organizationSplash: "Màn hình chào mừng tổ chức",
    cropsHarvestAlert: "Cảnh báo thu hoạch cây trồng",
    alertCrop: "Cây trồng",
    alertCropInfo: "Cây trồng mà bạn sẽ nhận được cảnh báo",
    alertCountry: "Quốc gia",
    alertCountryInfo: "Quốc gia mà bạn sẽ nhận được cảnh báo",
    alertRegion: "Khu vực",
    alertRegionInfo: "Khu vực của quốc gia đã chọn mà bạn sẽ nhận được cảnh báo",
    alertMaximum: "Số lượng tối đa",
    alertMaximumInfo: "Số lượng tối đa cho phép sau đó bạn sẽ nhận được cảnh báo",
    selectCrop: "Chọn cây trồng",
    alertFor: "Chọn ai nhận cảnh báo",
    alertAdmin: "Cảnh báo quản trị viên",
    alertFarmer: "Cảnh báo nông dân",
    selectCountry: "Chọn quốc gia",
    maxProduction: "Sản lượng tối đa / Hecta / Năm",
    maxAllowed: "Tối đa cho phép / Ha / Năm",
    alert: "Cảnh báo",
    defaultOtpOrganization: "OTP tổ chức mặc định cho đăng ký",
    crop: "Cây trồng",
    maxProductionError: "Phải nhập sản lượng tối đa",
    selectCountryError: "Vui lòng chọn quốc gia trước",
    selectCropError: "Vui lòng chọn cây trồng trước",
    unitError: "Vui lòng đặt sản lượng tối đa và đơn vị",
    per_hour: "Mỗi giờ",
    per_day: "Mỗi ngày",
    per_minute: "Mỗi phút",
    per_week: "Mỗi tuần",
    per_month: "Mỗi tháng",
    per_year: "Mỗi năm",
    per_second: "Mỗi giây",
    per_session: "Mỗi phiên",
    per_login: "Mỗi lần đăng nhập",
    mins: "Phút",
    hours: "Giờ",
    days: "Ngày",
    weeks: "Tuần",
    months: "Tháng",
    years: "Năm",
    seconds: "Giây",
    customized: "Tùy chỉ định",
  },
  dashboardSection: {
    greenBeansData: "Quản lý Đậu Xanh",
    dryMilling: "Xay Khô",
    modules: "Mô-đun",
    allowances: "Phép",
    maxUserAllowed: "Số Người Dùng Tối Đa",
    satelliteReportsAllowed: "Báo Cáo Vệ Tinh Cho Phép",
    advanceReport: "Báo Cáo Nâng Cao Cho Phép",
    subscriptionUpTo: "Đăng Ký Đến",
    roleAllowed: "Vai Trò Cho Phép",
    moduleAllowed: "Mô-đun Cho Phép",
    registeredUsers: "Người Dùng Đã Đăng Ký",
    validMemberships: "Thành Viên Hiệu Lực",
    activeUsers: "Người Dùng Hoạt Động",
    deactivatedUsers: "Người Dùng Bị Vô Hiệu Hóa",
    membershipValidity: "Hiệu Lực Thành Viên",
    lessThan1Month: "Ít Hơn 1 Tháng",
    months1to6: "1-6 Tháng",
    months6to12: "6-12 Tháng",
    moreThan1Year: "Hơn 1 Năm",
    cropOverview: "Tổng Quan Về Cây Trồng",
    plantations: "Vườn Cây Trồng",
    coffeeData: "Dữ Liệu Cà Phê",
    availableModules: "Các Mô-đun Có Sẵn",
    roleList: "Nông Dân, Trạm Mua Sắm, Kho",
    memberData: "Dữ Liệu Thành Viên",
    userType: "Loại Người Dùng",
    registered: "Đã Đăng Ký",
    offlineUsers: "Người Dùng Ngoại Tuyến",
    lessThanOneMonth: "< 1 Tháng",
    cacaoData: "Dữ Liệu Cacao",
    dryCacao: "Cacao Khô",
    traceability: "Theo dõi",
  },
  adminRoles: {
    adminRoles: "Vai Trò Quản Trị",
    roleName: "Tên Vai Trò",
    description: "Mô Tả",
    viewPermissions: "Xem Quyền",
    createAdminRole: "TẠO VAI TRÒ QUẢN TRỊ",
    enterDesHere: "Nhập mô tả của bạn ở đây",
    deleteRole: "Xóa Vai Trò",
    deleteMsg: "Bạn có chắc muốn xóa vai trò không?",
    roleReq: "Yêu cầu tên vai trò",
    roleLimit: "Tên vai trò phải ít hơn 15 ký tự",
    desReq: "Yêu cầu mô tả",
    desLimit: "Mô tả phải ít hơn 40 ký tự",
    roleSuccess: "Vai trò được tạo thành công",
    editAdminRole: "Chỉnh sửa Vai Trò Quản Trị",
    roleUpdated: "Vai Trò Đã Cập Nhật",
    noRole: "Không Tìm Thấy Vai Trò Quản Trị",
    noRoleMsg:
      "Vui lòng tạo vai trò quản trị bằng cách sử dụng nút 'Tạo Vai Trò Quản Trị' ở trên",
  },
  membershipplanSection: {
    noAdminMembershipsFound: "Không tìm thấy thành viên quản trị viên",
    pleaseAddMembership: "Vui lòng thêm thành viên bằng cách sử dụng nút 'Thêm thành viên' ở trên",
    defaultMembership: "Thành viên mặc định",
    areYouSureDefault: "Bạn có chắc chắn muốn đặt loại thành viên này làm mặc định không?",
    changeDefaultPlan: "Thay đổi kế hoạch mặc định",
    defaultPlan: "KẾ HOẠCH MẶC ĐỊNH",
    planDuration: "Thời gian kế hoạch",
    planFee: "Phí kế hoạch",
    satelliteReport: "BÁO CÁO VỆ TINH",
    advanceReport: "BÁO CÁO NÂNG CAO",
    addMembership: "THÊM THÀNH VIÊN",
    addMembershipPlan: "Thêm kế hoạch thành viên",
    editMembershipPlan: "Chỉnh sửa kế hoạch thành viên",
    accessSetelite: "Truy cập vào báo cáo vệ tinh (Bộ 5 báo cáo)",
    accessAdvanceReport: "Truy cập vào báo cáo nâng cao",
    memPlanReq: "Yêu cầu kế hoạch thành viên",
    memPlanReqLimit: "Kế hoạch thành viên phải ít hơn 20 ký tự",
    SatelliteReq: "Yêu cầu báo cáo vệ tinh",
    advancedReportReq: "Yêu cầu báo cáo nâng cao",
    durationReq: "Yêu cầu thời gian thành viên",
    feeReq: "Yêu cầu phí thành viên",
    cantLesThenZero: "Không thể nhỏ hơn 0",
    roleReq: "Yêu cầu vai trò người dùng",
    selectPlan: "Chọn kế hoạch",
    planType: "Loại kế hoạch",
    enterprise: "Doanh nghiệp",
    noOfUsersAllowed: "Số lượng người dùng được phép",
    noOfFarms: "Số lượng trang trại",
    perUser: "Mỗi người dùng",
    perFarm: "Mỗi trang trại",
    accessToDeforestationReport: "Truy cập vào báo cáo phá rừng (Mỗi người dùng)",
    satelliteReportPackage: "Gói báo cáo vệ tinh",
    basicFarmLevelReports: "Báo cáo cấp trang trại cơ bản",
    advancedFarmLevelReports: "Báo cáo cấp trang trại nâng cao",
    largeAreaReports: "Báo cáo khu vực lớn"
  },
  tickets: {
    actions: {
      create: "Tạo vé",
      delete: "Xóa vé",
      edit: "Chỉnh sửa vé"
    },
    areaOfRequest: "Khu vực yêu cầu",
    assignee: "Người được giao",
    deleteTicket: {
      confirmation: "Bạn có chắc chắn muốn xóa vé {0} không?"
    },
    dueDate: "Ngày đến hạn",
    filters: {
      ticketFor: "Vé cho"
    },
    form: {
      ticketType: {
        admin: "Tạo vé cho quản trị viên Dimitra",
        user: "Tạo vé cho người dùng ứng dụng"
      }
    },
    markAsRead: "Đánh dấu là đã đọc",
    messages: {
      created: {
        success: "Tạo vé thành công"
      },
      deleted: {
        success: "Xóa vé thành công"
      }
    },
    noData: "Không tìm thấy vé!",
    noDataHelpText: `Bạn chưa có vé nào được giao cho{0}bạn. Nhấp vào nút "Tạo vé"{1}ở đầu màn hình này để bắt đầu.`,
    pickerInMenu: "Trình chọn trong menu",
    priority: {
      high: "Cao",
      label: "Ưu tiên"
    },
    reply: "Trả lời",
    requestedDateTime: "Ngày và giờ yêu cầu",
    requestorDetails: "Chi tiết người yêu cầu",
    requestorEmail: "Email người yêu cầu",
    subject: "Chủ đề",
    ticketsForItems: {
      all: "Tất cả",
      dimitraAdmin: "Quản trị viên Dimitra",
      multipleUsers: "Nhiều người dùng",
      singleUser: "Một người dùng"
    },
    title: "Vé"
  },
  memberDataSection: {
    import: "Nhập",
    buyingStation: "Trạm Mua Sắm",
    continue: "Tiếp tục",
    farmerId: "ID Nông dân",
    farmerName: "Tên Nông dân",
    farmerAddress: "Địa chỉ Nông dân",
    quality: "Chất lượng",
    quantity: "Số lượng",
    importAll: "Nhập Tất cả",
    importSelected: "Nhập Được Chọn",
    fileLoaded: "Tệp được tải thành công",
    incorrectHeaders: "Tiêu đề không chính xác",
    processingBatch: "Đang xử lý Batch",
    purchaseOrder: "Đơn đặt hàng",
    buyingStationDetails: "Chi tiết trạm mua hàng",
    buyingStationUsers: "Người dùng trạm mua hàng",
    activityLog: "Nhật ký hoạt động",
    startDate: "Ngày bắt đầu",
    endDate: "Ngày kết thúc",
    purchasingOrder: "Đơn đặt hàng",
    totalCoffeeCherry: "Tổng số cà phê cherry",
    airHumidity: "Độ ẩm không khí",
    density: "Mật độ",
    temperature: "Nhiệt độ",
    beanMoistureContent: "Nước hạt cà phê",
    processType: "Loại Quy trình",
    batchRating: "Chọn Điểm Của Batch",
    purchaseDate: "Ngày mua",
    selectFarmer: "Chọn Nông dân",
    selectFarm: "Chọn Nông trại",
    selectPlantation: "Chọn Đồn điền",
    coffeeVariety: "Đa dạng Cà phê",
    coffeeSpecies: "Loại Cà phê",
    coffeeCherryQuantity: "Số lượng Cà phê Cherry",
    coffeeCherryQuality: "Chất lượng Cà phê Cherry",
    coffeeType: "Loại Cà phê",
    pricePerKg: "Giá mỗi Kg",
    processingDone: "Xử lý Đã hoàn thành",
    processedCoffeeOut: "Cà phê đã xử lý",
    farmer: "Nông dân",
    farm: "Nông trại",
    plantation: "Đồn điền",
    farmsChart: "Biểu đồ Nông trại",
    // Lately added
    farmers: "Nông dân",
    farmLimitUsed: "Giới hạn Nông trại Đã Sử Dụng",
    phoneNumber: "Số điện thoại",
    farmSize: "Kích thước Nông trại",
    farmLocation: "Nông trại/Địa điểm",
    date: "Ngày",
    status: "Trạng thái",
    noFarmers: "Không tìm thấy Nông dân",
    approveReject: "Chấp nhận/Từ chối",
    farms: "Nông trại",
    crops: "Cây trồng",
    equipment: "Thiết bị",
    noFarms: "Không tìm thấy Nông trại",
    views: "Xem",
    selectStatus: "Chọn Trạng thái",
    approved: "Đã chấp nhận",
    rejected: "Đã từ chối",
    reject: "Từ chối",
    approve: "Chấp nhận",
    cancel: "Hủy",
    add: "Thêm",
    describeYourReason: "Mô tả lý do của bạn ở đây",
    userInformation: "Thông tin Người Dùng",
    userFarmRequest: "Yêu cầu Nông trại của Người Dùng",
    userFarmInformation: "Thông Tin Nông Trại của Người Dùng",
    activity: "Hoạt động",
    activityType: "Loại Hoạt động",
    farmZone: "Vùng Nông trại",
    farmerView: "Xem của Nông dân",
    cropType: "Loại Cây trồng",
    cropVarity: "Loại Cây trồng",
    area: "Diện tích",
    cost: "Chi phí",
    geofence: "Vùng địa lý",
    map_views: "Xem Bản đồ",
    viewAllFarms: "Xem Tất cả Nông trại",
    farmersDetails: "Chi Tiết Nông Dân",
    download: "Tải về",
    pOrder: {
      addNew: "Thêm Mới",
      viewAll: "Xem Tất cả",
      selectDate: "Chọn ngày",
      makeSelection: "Chọn",
      coffeeType: "Nhập số lượng cà phê",
      enterPrice: "Nhập Giá",
      reqPurchaseDate: "Yêu cầu nhập ngày mua",
      reqFarmer: "Yêu cầu chọn Nông dân",
      reqCoffeeQnty: "Yêu cầu nhập Số lượng Cà phê Cherry",
      reqPrice: "Yêu cầu nhập Giá mỗi Kg",
      grandTotal: "TỔNG CỘNG",
      selectDateRange: "Chọn Khoảng ngày",
      import: "Nhập",
      purchaseId: "ID Đơn mua",
      purchaseDate: "Ngày mua",
      farmerName: "Tên Nông dân",
      quality: "Chất lượng",
      quantity: "Số lượng",
      pricePerKg: "Giá mỗi Kg",
      selectBuyingStation: "Chọn Trạm mua sắm",
      searchUser: "Tìm kiếm Người Dùng",
    },
    farmActivity: "Hoạt động trang trại",
    showOnMap: "Hiển thị trên bản đồ",
    farmInformation: "Thông tin trang trại",
    dateOfEntry: "Ngày nhập",
    farmID: "ID trang trại",
    ownershipType: "Loại sở hữu",
    locationAddress: "Địa chỉ",
    goalType: "Loại mục tiêu",
    totalSize: "Tổng diện tích",
    zones: "Khu vực",
    farmActivities: "Hoạt động trang trại",
    farmDetails: "Chi tiết trang trại",
    totalFarmsRegistered: "Tổng số trang trại đã đăng ký",
    totalFarmArea: "Tổng diện tích trang trại",
    totalZone: "Tổng khu vực",
    zone: "Khu vực",

    totalCost: "Tổng chi phí",
    selectFarmZone: "Chọn khu vực/trang trại",
    productionType: "Loại sản xuất",
    certifications: "Chứng nhận",
    geofences: "Hàng rào địa lý",

  },
  roleRequest: {
    roleRequest: "Yêu cầu Vai trò",
    userRole: "Vai trò Người dùng",
    approve: "Chấp nhận",
    reject: "Từ chối",
    username: "Tên người dùng",
    email: "Email",
    phone: "Số điện thoại",
    roleAssigned: "Vai trò được gán",
    roleRequested: "Vai trò được yêu cầu",
    requestedDate: "Ngày yêu cầu",
    updateRoleRequest: "Cập nhật Yêu cầu Vai trò",
    message: "Thông điệp",
    update: "Cập nhật",
  },
  faqSection: {
    createFaq: "TẠO FAQ",
    createTopic: "Tạo Chủ đề",
    selectTopic: "Chọn Chủ đề",
    faqQuestion: "Câu hỏi FAQ",
    faqAnswer: "Trả lời FAQ",
    uploadImgVid: "Tải Ảnh/Video lên",
    disInFaq: "Hiển thị trong phần FAQ",
    editFaq: "Chỉnh sửa FAQ",
    topicName: "Tên Chủ đề",
    parentTopic: "Chủ đề cha",
    editTopic: "Chỉnh sửa Chủ đề",
    createSection: "Vui lòng tạo mục đầu tiên",
    createTopicFirst: "Vui lòng tạo chủ đề trước",
    questionReq: "Câu hỏi FAQ là bắt buộc",
    answerReq: "Trả lời FAQ là bắt buộc",
  },
  reports: {
    usersByStatus: "Người dùng theo trạng thái",
    usersByGender: "Người dùng theo giới tính",
    gen: "Giới tính",
    gender: "Biểu đồ giới tính",
    male: "Nam",
    female: "Nữ",
    other: "Khác",
    unspefied: "Chưa xác định",
    byCountry: "Theo quốc gia",
    avgPriceFarmer: "Giá bán trung bình của tất cả nông dân",
    avgPrice: "Giá bán trung bình mỗi nông dân",
    selectYear: "Chọn năm",
    total: "Tổng cộng",
    farmerName: "Tên nông dân",
    farmerProdChart: "Biểu đồ sản xuất của nông dân",
    production: "Sản lượng",
    byProduction: "Theo sản lượng",
    byName: "Theo tên",
    descending: "Giảm dần",
    ascending: "Tăng dần",
    buyingStationProdChart: "Biểu đồ sản xuất trạm mua",
    buyingStation: "Trạm mua",
    buyingStationName: "Tên trạm mua",
    dryMilling: "Xay xát khô",
    dryMillingName: "Tên xay xát khô",
    dryMillingProdChart: "Biểu đồ sản xuất xay xát khô",
    view: "Xem",
    date: "Ngày",
    reports: "Báo cáo",
    today: "Hôm nay",
    week: "Tuần",
    month: "Tháng",
    year: "Năm",
    all: "Tất cả",
    selectCrop: "Chọn cây trồng",
    selectRegion: "Chọn vùng",
    selectProvinceState: "Chọn tỉnh/bang",
    downloadPdfReport: "Tải báo cáo PDF",
    export: "Xuất",
    search: "Tìm kiếm",
    yield: "Năng suất",
    avgAreaPerUnit: "Diện tích trung bình trong {unit}",
    yieldPerUnit: "Năng suất/{unit}",
    averageSellingPriceByAllFarmers: "Giá bán trung bình của tất cả nông dân",
    averageSellingPricePerFarmer: "Giá bán trung bình mỗi nông dân",
    pricePaid: "Giá đã trả",
    pests: {
      pestReport: "Báo cáo sâu bệnh",
      filterByCrops: "Lọc theo cây trồng",
      pestStatistics: "Thống kê sâu bệnh",
      regions: "Vùng",
      occurrences: "Lần xuất hiện",
      pestChart: "Biểu đồ sâu bệnh",
      totalArea: "Tổng diện tích",
      pestName: "Tên sâu bệnh",
      region: "Vùng",
      crop: "Cây trồng",
      listByLand: "Liệt kê theo đất"
    },
    regions: {
      regionalReport: "Báo cáo vùng",
      listByFarm: "Liệt kê theo trang trại",
      listByFarmers: "Liệt kê theo nông dân",
      listByYield: "Liệt kê theo năng suất",
      regionalStatistics: "Thống kê vùng",
      countries: "Quốc gia",
      states: "Tỉnh/Bang",
      city: "Thành phố/Thị trấn/Làng",
      farmsIn: "Trang trại tại",
      regionalChart: "Biểu đồ vùng",
      farms: "Trang trại",
      regionName: "Tên vùng",
      farmers: "Nông dân",
      yield: "Năng suất/Acre"
    },
    dashboard: {
      topCharts: "Biểu đồ hàng đầu",
      regions: "Vùng",
      noOfFarms: "Số trang trại/Vùng",
      provinces: "Tỉnh/Bang",
      landArea: "Diện tích đất",
      avgFarmerLand: "Diện tích trung bình của nông dân",
      viewAll: "Xem tất cả",
      crops: "Cây trồng",
      plantedAreaCrop: "Diện tích trồng/Cây trồng",
      plantedArea: "Diện tích trồng",
      avgYieldCrop: "Năng suất trung bình/Cây trồng",
      averageYield: "Năng suất trung bình",
      yieldChart: "Biểu đồ năng suất",
      selectFarm: "Chọn trang trại",
      soilQuality: "Chất lượng đất",
      pests: "Sâu bệnh",
      occurrences: "Lần xuất hiện",
      equipments: "Trang thiết bị",
      goalAchievedChart: "Biểu đồ mục tiêu đạt được",
      soilValues: "Giá trị đất",
      soil: "Đất",
      showReport: "Hiển thị báo cáo trên bảng điều khiển",
      selectAll: "Chọn tất cả"
    },
    weight: "Khối lượng",
    quality: "Chất lượng",
    price: "Giá"
  },
  traceability: {
    traceability: "Truy xuất nguồn gốc",
    traceabilityManagement: "Quản lý truy xuất nguồn gốc",
    coffeeTraceabilityMngmnt: "Quản lý truy xuất nguồn gốc cà phê",
    traceabilityPage: "Trang truy xuất nguồn gốc",
    labelDesigner: "Thiết kế nhãn",
    additionalInformation: "Thông tin bổ sung",
    coffeeInformation: "Thông tin cà phê",
    info1: "Cung cấp thông tin về các biểu trưng bổ sung của sản phẩm của bạn. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc cà phê.",
    cropsinfo1: "Cung cấp thông tin về các biểu trưng bổ sung của sản phẩm của bạn. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc.",
    addSlogan: "Thêm khẩu hiệu",
    sloganToolTip: "Thêm khẩu hiệu vào sản phẩm của bạn. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc.",
    sloganHint: "Thêm khẩu hiệu vào sản phẩm của bạn. Khẩu hiệu phải có tối đa 60 ký tự. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc.",
    sloganLengthError: "Độ dài khẩu hiệu quá dài",
    additionalLogos: "Biểu trưng bổ sung",
    title: "Tiêu đề",
    description: "Mô tả",
    mapLink: "Liên kết bản đồ",
    mapLinkTooltip: "Cung cấp liên kết bản đồ cho sản phẩm của bạn.",
    originCountryTitle: "Tên quốc gia xuất xứ",
    enterOriginCountryTitle: "Nhập tên quốc gia xuất xứ",
    enterCountryDescription: "Cung cấp thông tin thú vị về quốc gia xuất xứ",
    originatingCountryTooltip: "Cung cấp thông tin về quốc gia xuất xứ của sản phẩm của bạn.",
    corporativeTitle: "Tên hợp tác xã",
    enterCorporativeTitle: "Nhập tên hợp tác xã",
    introDescription: "Thông tin bổ sung có thể bao gồm thông tin sản xuất, trung gian chuỗi cung ứng, chi tiết vận chuyển, điều kiện lưu trữ, chế biến, tuân thủ quy định, v.v.",
    corporativeTooltip: "Cung cấp thông tin về hợp tác xã.",
    coperativeDescriptionTooltip: "Cung cấp thông tin về hợp tác xã mà nông trại của bạn liên kết.",
    websiteLink: "Liên kết  trang web",
    addMedia: "Thêm phương tiện",
    uploadImageVideo: "Tải lên hình ảnh/video",
    uploadImage: "Tải lên hình ảnh",
    origin: "Nguồn gốc",
    originationCountry: "Quốc gia xuất xứ",
    info2: "Cung cấp thông tin về quốc gia xuất xứ của sản phẩm của bạn. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc cà phê.",
    cropsinfo2: "Cung cấp thông tin về quốc gia xuất xứ của sản phẩm của bạn. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc.",
    countryImage: "Hình ảnh quốc gia",
    traceabilityImage: "Hình ảnh truy xuất nguồn gốc",
    institutionalInfo: "Thông tin hợp tác xã",
    info3: "Nếu nông trại của bạn là một phần của hợp tác xã, vui lòng cung cấp thông tin về hợp tác xã đó.",
    cooperativeLogo: "Biểu trưng hợp tác xã",
    traceabilityIntro: "Giới thiệu truy xuất nguồn gốc",
    info4: "Cung cấp thêm thông tin về việc theo dõi và truy xuất sản phẩm của bạn qua toàn bộ chuỗi cung ứng—từ sản xuất hoặc nguồn gốc đến người tiêu dùng cuối.",
    addLabel: "Thêm nhãn",
    chooseTitle: "Chọn tiêu đề",
    chooseLabelDesign: "Chọn mẫu thiết kế nhãn",
    uploadYourLogo: "Tải lên biểu trưng của bạn",
    info5: "Hướng dẫn: Kích thước hình ảnh phải ít nhất là 1000 x 1000 pixel hình vuông. Bạn có thể chọn PNG trong suốt để đồng bộ với màu nền.",
    chooseTemplateColors: "Chọn màu mẫu",
    backgroundColor: "Màu nền",
    foregroundColor: "Màu tiền cảnh",
    labelStatus: "Trạng thái nhãn",
    inactive: "Không hoạt động",
    download: "Tải xuống",
    enterLabelTitle: "Nhập tiêu đề nhãn",
    enableLogoProcessing: "Bật xử lý biểu trưng",
  },
  cacaoTraceability: {
    traceability: "truy xuất nguồn gốc",
    cacaoTraceabilityMngmnt: "Quản lý truy xuất nguồn gốc cacao",
    traceabilityPage: "Trang truy xuất nguồn gốc",
    labelDesigner: "Nhà thiết kế nhãn",
    additionalInformation: "Thông tin bổ sung",
    info1: "Cung cấp thông tin về các logo bổ sung của sản phẩm của bạn. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc cacao.",
    addSlogan: "Thêm khẩu hiệu",
    additionalLogos: "Logo bổ sung",
    title: "Tiêu đề",
    description: "Mô tả",
    mapLink: "Liên kết bản đồ",
    websiteLink: "Liên kết trang web",
    addMedia: "Thêm phương tiện",
    uploadImageVideo: "Tải lên hình ảnh/video",
    origin: "Xuất xứ",
    info2: "Cung cấp thông tin về quốc gia xuất xứ của sản phẩm của bạn. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc cacao.",
    countryImage: "Hình ảnh quốc gia",
    institutionalInfo: "Thông tin tổ chức",
    info3: "Cung cấp thông tin về công ty/hợp tác xã của bạn, chia sẻ với người tiêu dùng về những công việc liên quan mà bạn đã làm. Thông tin này sẽ được công khai trên trang truy xuất nguồn gốc cacao.",
    cooperativeLogo: "Logo hợp tác xã",
    traceabilityIntro: "Giới thiệu về truy xuất nguồn gốc",
    info4: "Phần này sẽ cung cấp cho người tiêu dùng quyền truy cập vào toàn bộ lịch sử sản xuất và chế biến cà phê. Mô tả tầm quan trọng của việc truy xuất nguồn gốc đối với công ty/hợp tác xã của bạn và với thế giới.",
    addLabel: "Thêm nhãn",
    chooseTitle: "Chọn tiêu đề",
    chooseLabelDesign: "Chọn mẫu thiết kế nhãn",
    uploadYourLogo: "Tải lên logo của bạn",
    info5: "Hướng dẫn: Kích thước hình ảnh phải ít nhất là 1000 x 1000 pixel vuông. Bạn có thể chọn PNG trong suốt để đồng bộ với màu nền.",
    chooseTemplateColors: "Chọn màu mẫu",
    backgroundColor: "Màu nền",
    foregroundColor: "Màu tiền cảnh",
    labelStatus: "Trạng thái nhãn",
    inactive: "Không hoạt động",
    download: "Tải xuống",
    enterLabelTitle: "Nhập tiêu đề nhãn",
  
    originTitle: "Tiêu đề xuất xứ",
    corporativeTile: "Tiêu đề hợp tác xã",
    enterSlogan: "Nhập khẩu hiệu",
    enterTitle: "Nhập tiêu đề",
    enterDescription: "Nhập mô tả",
    enterMapLink: "Nhập liên kết bản đồ",
    enterWebsiteLink: "Nhập liên kết trang web",
  },
  setting: {
    wholeNumMessage: "Phải là số nguyên",
    profileAuthSetting: "Cài đặt xác thực hồ sơ",
    logInOutSetting: "Cài đặt đăng nhập/đăng xuất",
    autoLogout: "Tự động đăng xuất",
    unsuccessfulLoginAttempt: "Nỗ lực đăng nhập không thành công",
    unsuccessfulLoginLockPeriod: "Thời gian khóa đăng nhập không thành công",
    passCriteriaSetup: "Thiết lập tiêu chí mật khẩu",
    passLength: "Độ dài mật khẩu",
    noUniquePassRequired: "Số lượng mật khẩu duy nhất yêu cầu",
    maxPassAge: "Tuổi thọ tối đa của mật khẩu",
    acceptableRangeOfChars: "Phạm vi ký tự chấp nhận",
    upperCase: "Chữ hoa",
    lowerCase: "Chữ thường",
    numbers: "Số",
    specialChars: "Ký tự đặc biệt",
    uniqueSymbols: "Ký hiệu duy nhất",
    loadingData: "Đang tải dữ liệu...",
    currency: "Tiền tệ",
    codeActivationTime: "Thời gian kích hoạt mã",
    changeGlobalSetting: "Thay đổi cài đặt toàn cầu",
    globalSetting: "Cài đặt toàn cầu",
    generalSetting: "Cài đặt chung",
    hour: "Giờ",
    days: "Ngày",
    minutes: "Phút",
    perDay: "Mỗi ngày",
    perHour: "Mỗi giờ",
    customised: "Tùy chỉnh",
    areaUnit: "Đơn vị diện tích",
    weightUnit: "Đơn vị trọng lượng",
    minimumPwdLen: "Độ dài mật khẩu tối thiểu cho phép",
    otpPlaceholder: "Tạo OTP 6 chữ số",
    generateOTP: "Tạo OTP",
    smallFarm: "Trang trại nhỏ",
    inclusive: "Bao gồm",
    from: "Từ",
    to: "Đến",
    mediumFarm: "Trang trại vừa",
    largeFarm: "Trang trại lớn",
    requiredMessage: "Trường này là bắt buộc",
    nonNegativeMessage: "Trường này phải là số không âm",
    fieldToGreaterThanFrom: "Trường này phải lớn hơn trường 'Từ'",
    fieldToGreaterThanFromMedium: "Trường này phải lớn hơn trường 'Đến' của trang trại nhỏ",
    fieldToGreaterThanMediumTo: "Trường này phải lớn hơn trường 'Đến' của trang trại vừa",
  },
  coffeeData: {
    windBreaker: "Cây chắn gió",
    horticultureInfo: "Cây trồng horticulture",
    shadeTree: "Cây che nắng",
    coffeeVariety: "Loại cà phê",
    coffeeSpecies: "Loài cà phê",
    updateWindBreaker: "Cập nhật loại cây chắn gió",
    addWindBreaker: "Thêm loại cây chắn gió mới",
    updateHorticultureInfo: "Cập nhật loại cây trồng horticulture",
    addHorticultureInfo: "Thêm loại cây trồng horticulture mới",
    updateShadeTree: "Cập nhật loại cây che nắng",
    addShadeTree: "Thêm loại cây che nắng mới",
    updateCoffeeVariety: "Cập nhật loại cà phê",
    addCoffeeVariety: "Thêm loại cà phê mới",
    deleteVarietyTitle: "Xóa loại",
    deleteVarietyMessage: "Bạn có chắc chắn muốn xóa Loại?",
    updateCoffeeSpecie: "Cập nhật loại cà phê",
    deleteSpecieTitle: "Xóa loại",
    deleteSpecieMessage: "Bạn có chắc chắn muốn xóa Loại?",
    addCoffeeSpecie: "Thêm loại cà phê mới",
    variety: "Loại",
    selectVariety: "Chọn Loại",
    deleteCoffeeRecord: "Bạn có chắc chắn muốn xóa bản ghi?",
    deleteCoffeeData: "Xóa dữ liệu cà phê",
    topicRequired: "Chọn Chủ đề là bắt buộc",
    coffeeAddSuccess: "Loại cà phê được thêm thành công.",
    treeTypeSuccess: "Loại cây được thêm thành công.",
    treeTypeUpdateSuccess: "Loại cây được cập nhật thành công.",
    coffeeVarietySuccess: "Loại cà phê được thêm thành công.",
    coffeeSpecieSuccess: "Loại cà phê được cập nhật thành công.",
    nameRequired: "Tên là bắt buộc",
    notFound: "Không tìm thấy dữ liệu quản trị cà phê",
  },
  cacaoData: {
    cacao: "Cacao",
    cacaoVariety: "Loại cacao",
    cacaoSpecies: "Loài cacao",
    deleteCacaoData: "Xóa dữ liệu cacao",
  },

  plantation: {
    farmerName: "Tên nông dân",
    phoneNumber: "Số điện thoại",
    plantationName: "Tên vườn",
    farm: "Nông trại",
    location: "Vị trí",
    updatePlantationStatus: "Cập nhật trạng thái vườn",
    update: "CẬP NHẬT",
  },
  activationKey: {
    enterActivationKey: "Vui lòng nhập mã kích hoạt để đăng ký người dùng mới",

    countryRequired: "Quốc gia là bắt buộc",
    activationKeyRequired: "Mã kích hoạt là bắt buộc",
    activationKey: "Mã kích hoạt",
    activationKeyLimit: "Mã kích hoạt quá ngắn",
    membershipRoleFilterDesc: "Lọc Kế hoạch thành viên theo vai trò",
    email: "Email",
    filterBy: "Lọc theo",
    membershipRoleFilter: "Bộ lọc vai trò thành viên",
    // enterActivationKey: "Please enter activation key to register a new user",
    // activationKeyLimit: "Minimum 15 characters",
    // countryRequired: "Country Code is required",

    appointSalesManager: "Bổ nhiệm Quản lý Bán hàng",
    appointManager: "BỔ NHIỆM QUẢN LÝ",
    salesManAppSuccess: "BỔ NHIỆM QUẢN LÝ BÁN HÀNG THÀNH CÔNG",
    uploadData: "TẢI LÊN DỮ LIỆU CSV ĐÃ GÁN",
    uploadUserData: "Vui lòng tải lên tệp dữ liệu người dùng",
    downloadCsv: "Tải xuống tệp .csv mẫu để theo cấu trúc",
    downloadSample: "Tải xuống tệp mẫu",
    dragDrop: "Kéo và thả hoặc",
    browse: "duyệt",
    yourFile: "tệp của bạn",
    incorectFileType: "Loại tệp không đúng",
    somethingWentWrong: "Có lỗi xảy ra",
    fileUploadedSuccess: "Tệp tải lên thành công",
    countRecords: "Số bản ghi",
    sendNow: "GỬI NGAY BÂY GIỜ",
    fileName: "tên-tệp",
    assignActKey: "Đang gán mã kích hoạt",
    actKeyAssSucc: "Mã kích hoạt được gán thành công",
    viewActKey: "XEM CÁC MÃ KÍCH HOẠT",
    actKeyQuota: "Hạn mức mã kích hoạt",
    genActKey: "Mã kích hoạt được tạo ra",
    remActKey: "Mã kích hoạt còn lại",
    penUsed: "Khóa đang chờ và Đã sử dụng",
    activationKeyAss: "Mã kích hoạt đã gán",
    activationKeyUnass: "Mã kích hoạt chưa được gán",
    keysAct: "Khóa đã kích hoạt",
    uploadedFiles: "Tệp đã tải lên",
    generateActKey: "TẠO MÃ KÍCH HOẠT",
    showData: "Hiển thị dữ liệu",
    noDataFound: "Không có dữ liệu",
    pleaseGenKey:
      'Vui lòng tạo mã kích hoạt bằng cách sử dụng nút "Tạo mã kích hoạt"',
    noActKey: "Chưa có mã kích hoạt được tạo ra",
    buttonAbv: "nút ở trên",
    numberOfActKey: "Số lượng mã kích hoạt",
    membershipRole: "Vai trò thành viên",
    membershipPlan: "Kế hoạch thành viên",
    comments: "Bình luận",
    genKeys: "TẠO KHÓA",
    keysNum: "Số khóa",
    phoneNumber: "Số điện thoại",
    keysStatus: "Trạng thái khóa",
    ActivationKeysList: "Danh sách mã kích hoạt",
    back: "TRỞ LẠI",
    usingActKeys: 'bằng cách sử dụng nút "Tạo mã kích hoạt"',
    pleaseGenActKeyss: "Vui lòng tạo mã kích hoạt",
    clearAllFilters: "XÓA TẤT CẢ BỘ LỌC",
    salesManager: "Quản lý bán hàng",
    clearAll: "XÓA TẤT CẢ",
    generatedBy: "Được tạo ra bởi",
    numberOfKeys: "Số lượng khóa",
    action: "Hành động",
    viewAllUplFiles: "XEM TẤT CẢ TỆP ĐÃ TẢI LÊN",
    bulkUploadUsers: "TẢI LÊN NGƯỜI DÙNG HỘP",
    noActivationKeyFound: "Không tìm thấy mã kích hoạt",
    pleaseCreateAdminRole: "Vui lòng tạo vai trò quản trị bằng cách sử dụng",
    btnCreateAdmin: "nút 'Tạo vai trò quản trị' ở trên",
    donwloadAsCsv: "Tải xuống dưới dạng CSV",
    donwloadAsPdf: "Tải xuống dưới dạng PDF",
    assignSalesManager: "Gán Quản lý Bán hàng",
    shareViaEmail: "Chia sẻ qua Email",
    sendEmail: "GỬI EMAIL",
    emailSend: "EMAIL GỬI THÀNH CÔNG",
    donwload: "Tải xuống",
    deleteFile: "Xóa tệp",
    invalidFileData: "Dữ liệu mã kích hoạt trên tệp không hợp lệ",
  },

  surveyBuilder: {
    farmName: "Trang trại",
    farmerName: "Tên nông dân",
    scores: "Điểm số",
    clearSelection: "Xóa tất cả người dùng",
    addNewSurvey: "Thêm khảo sát mới",
    surveyTitle: "Tiêu đề khảo sát",
    surveyName: "Tên khảo sát",
    surveyDescription: "Mô tả khảo sát",
    describeSurvey: "Mô tả khảo sát",
    enableScheduling: "Kích hoạt lịch trình",
    selectedDate: "Ngày đã chọn",
    multiStepSurvey: "Khảo sát nhiều bước",
    multiStepSurveyDetails: "Dựa trên số lượng câu hỏi trong mỗi bước, tất cả câu hỏi trong khảo sát sẽ được nhóm lại và hiển thị theo từng bước.",
    multiStep: "Nhiều bước",
    noQuestionEachStep: "Số câu hỏi trong mỗi bước",
    surveyStatus: "Trạng thái khảo sát",
    surveyStatusDetails: "Khảo sát chỉ có thể kích hoạt sau khi thêm câu hỏi. Khi kích hoạt, nông dân có thể bắt đầu gửi khảo sát.",
    selectUsers: "Chọn người dùng",
    selectUsersDetails: "Nếu tùy chọn người dùng bị vô hiệu hóa, khảo sát sẽ có sẵn cho tất cả người dùng. Nếu kích hoạt, bạn có thể chọn nhiều người dùng trong bước tiếp theo.",
    linkWithFarms: "Liên kết với trang trại",
    linkWithFarmsDetails: "Nếu kích hoạt, khảo sát sẽ liên kết với từng trang trại riêng lẻ. Nếu một nông dân có nhiều trang trại, mỗi trang trại sẽ có khảo sát riêng.",
    enabled: "Đã kích hoạt",
    disabled: "Đã vô hiệu hóa",
    cancel: "Hủy bỏ",
    next: "Tiếp tục",
    surveySettings: "Cài đặt khảo sát",
  
    selectSurveyUsers: "Chọn người dùng cho khảo sát",
    selectToProceed: "Vui lòng chọn người dùng để tiếp tục",
    searchUsers: "Tìm kiếm người dùng",
    usersSelected: "Người dùng đã chọn",
    conditional: "Có điều kiện",
    autoConditional: "Tự động có điều kiện",
    userName: "Tên người dùng",
    email: "Email",
    membershipType: "Loại thành viên",
    membershipValidity: "Hiệu lực thành viên",
    membershipRemainingDays: "Số ngày còn lại",
    membershipRole: "Vai trò thành viên",
    accountProgress: "Tiến độ tài khoản",
    status: "Trạng thái",
    active: "Hoạt động",
    deactivated: "Đã vô hiệu hóa",
    continue: "Tiếp tục",
    questions: "Câu hỏi",
    responses: "Phản hồi",
    deleteSurvey: "Xóa khảo sát",
    editSurvey: "Chỉnh sửa khảo sát",
    type: "Loại",
    compulsory: "Bắt buộc",
    createSurvey: "Tạo khảo sát",
    surveyBuilder: "Công cụ xây dựng khảo sát",
    surveyList: "Danh sách khảo sát",
    farm: "Trang trại",
    responseDate: "Ngày phản hồi",
    viewSurvey: "Xem khảo sát",
    question: "Câu hỏi",
    settings: "Cài đặt",
    addQuestion: "Thêm câu hỏi",
    surveysSubmitted: "Khảo sát đã nộp",
    surveyDetail: "Chi tiết khảo sát",
    conditionStatus: "Trạng thái điều kiện",
    conditionStatusDesc: "Người dùng đáp ứng điều kiện sẽ tự động đủ điều kiện cho khảo sát.",
  
    endSurvey: "Kết thúc khảo sát",
    publishSurvey: "Xuất bản khảo sát",
    copy: "Sao chép",
    view: "Xem",
    startDate: "Ngày bắt đầu",
    endDate: "Ngày kết thúc",
    chooseDate: "Chọn ngày",
    select: "Chọn",
    addSurveyQuestion: "Thêm câu hỏi khảo sát",
    editSurveyQuestion: "Chỉnh sửa câu hỏi khảo sát",
    questionScore: "Điểm câu hỏi",
    mandatory: "Bắt buộc",
    yes: "Có",
    no: "Không",
    options: "Tùy chọn",
    typeHere: "Nhập vào đây",
    add: "Thêm",
    optionsHint: "Vui lòng nhấn Enter để thêm câu trả lời hoặc nhấp vào Thêm",
    surveyProgress: "Khảo sát đang tiến hành",
    allResponses: "Tóm tắt tất cả phản hồi",
    responseQuestion: "Phản hồi theo câu hỏi",
    dateSubmitted: "Ngày nộp",
    answer: "Câu trả lời",
    totalScore: "Tổng điểm",
    score: "Điểm",
    singleSelection: "Chọn đơn",
    multipleSelection: "Chọn nhiều",
    if: "Nếu",
    then: "thì",
    noResponse: "Không có phản hồi",
    noSurveyFound: "Không tìm thấy khảo sát nào",
    createNewSurvey: 'Vui lòng tạo khảo sát bằng cách nhấn nút "Tạo khảo sát" phía trên',
    cannotPublish: "Không thể xuất bản khảo sát đã vô hiệu hóa!",
    deleteSurveyWarn: "Bạn có chắc chắn muốn xóa khảo sát không? Nếu bạn xóa, tất cả các câu hỏi và phản hồi sẽ bị xóa vĩnh viễn.",
    noQuestionFound: "Không tìm thấy câu hỏi nào",
    createQuestion: 'Vui lòng thêm câu hỏi trước bằng cách nhấn nút "THÊM CÂU HỎI" phía trên',
    deleteQuestion: "Bạn có chắc chắn muốn xóa câu hỏi không?",
    applyChanges: "Bạn muốn áp dụng các thay đổi này như thế nào?",
    editFutureSurveys: "CHỈ SỬA KHẢO SÁT TƯƠNG LAI",
    editLiveSurveyOnly: "CHỈ SỬA KHẢO SÁT ĐANG SỐNG",
    surveyIsLive: "Lưu ý rằng khảo sát hiện đang hoạt động, việc chỉnh sửa câu hỏi lúc này có thể ảnh hưởng đến các phản hồi trước đó. Để tránh các vấn đề, bạn có thể sao chép khảo sát để thực hiện các thay đổi.",
    clickToCopy: "Nhấp vào đây để tạo bản sao khảo sát",
    applyChangesNow: "ÁP DỤNG THAY ĐỔI NGAY",
    copySurvey: "Sao chép khảo sát",
    changeCopySurveyName: "Bạn có thể thay đổi tên của phiên bản khảo sát sao chép.",
  
    textField: "Trường văn bản",
    textArea: "Vùng văn bản",
    textFieldNumeric: "Trường văn bản số",
    radioButton: "Nút radio",
    checkBoxes: "Ô kiểm",
    fileAttachment: "Đính kèm tệp",
    digitalSignature: "Chữ ký số",
    gpsLocation: "Vị trí GPS",
    dynamicFarmer: "Nông dân động",
    dynamicGeofence: "Hàng rào địa lý động",
    dynamicCrop: "Cây trồng động",
    dynamicEquipment: "Thiết bị động",
    downloadSurvey: "Tải xuống khảo sát",
    downloadQuestion: "Chỉ tải câu hỏi",
    downloadResponse: "Tải tất cả phản hồi",
    chooseFileFormat: "Chọn định dạng tệp",
    surveyTitleLength: "Tiêu đề khảo sát phải ít hơn 100 ký tự",
    selectAllFiltered: "Chọn tất cả đã lọc",
    surveyDownloads: "Tải xuống khảo sát"
  },  
  dashboardReports: {
    appDataReports: "Báo Cáo Dữ Liệu Ứng Dụng",
    reports: "Báo Cáo",
  },
  cropsReport: "Báo Cáo Cây Trồng",
  today: "Hôm Nay",
  week: "Tuần",
  month: "Tháng",
  year: "Năm",
  all: "Tất Cả",
  cropsStatistics: "Thống Kê Cây Trồng",
  crops: "Cây Trồng",
  acres: "Mẫu Anh",
  totalPlantedArea: "Tổng Diện Tích Trồng",
  farmersChart: "Biểu Đồ Nông Dân",
  farmsChart: "Biểu Đồ Nông Trại",
  cropsName: "Tên Cây Trồng",
  farmers: "Nông Dân",
  farms: "Nông Trại",
  planted: "Đã Trồng",
  plantedArea: "Diện Tích Đã Trồng",
  harvested: "Đã Thu Hoạch",
  yieldAcre: "Năng Suất/Mẫu Anh",
  selectCrop: "Chọn Cây Trồng",
  listByYield: "Danh Sách theo Năng Suất",
  listByPlantedArea: "Danh Sách theo Diện Tích Trồng",
  equipmentReport: "Báo Cáo Thiết Bị",
  equipmentChart: "Biểu Đồ Thiết Bị",
  selectFarmer: "Chọn Nông Dân",
  selectFarmers: "Chọn Nông Dân",
  equipmentName: "Tên Thiết Bị",
  region: "Khu Vực",
  counts: "Số Lượng",
  large: "Lớn",
  medium: "Trung Bình",
  small: "Nhỏ",
  listByFarmer: "Danh Sách Theo Nông Dân",
  rowsPerPage: "Hàng Trên Mỗi Trang",
  farmersReport: "Báo Cáo Nông Dân",
  farmsReport: "Báo Cáo Nông Trại",
  farmersStatistics: "Thống Kê Nông Dân",
  farmStatistics: "Thống Kê Nông Trại",
  averageFarmerLand: "Trung Bình Diện Tích Nông Dân",
  largeFarmers: "Nông Dân Lớn",
  mediumFarmers: "Nông Dân Trung Bình",
  smallFarmers: "Nông Dân Nhỏ",
  listByLand: "Danh Sách Theo Diện Tích",
  listByFarm: "Danh Sách Theo Nông Trại",
  AvgLandAcre: "Trung Bình Diện Tích/Mẫu Anh",
  listbyCrop: "Danh Sách Theo Cây Trồng",
  listbyZone: "Danh Sách Theo Khu Vực",
  farmName: "Tên Nông Trại",
  zones: "Khu Vực",
  area: "Diện Tích",
  goalsAchievedReport: "Báo Cáo Mục Tiêu Đạt Được",
  listByCrops: "Danh Sách Theo Cây Trồng",
  goalsAchievedChart: "Biểu Đồ Mục Tiêu Đạt Được",
  goalsAchieved: "Mục Tiêu Đạt Được",
  goalsFailed: "Mục Tiêu Thất Bại",
  successRate: "Tỷ Lệ Thành Công",
  achieved: "Đạt Được",
  equipment: "Thiết Bị",
  pests: "Sâu Bệnh",
  regions: "Khu Vực",
  filterByCrops: "Lọc Theo Cây Trồng",
  searchCrops: "Tìm Kiếm Cây Trồng",
  batchCode: "Mã Lô",
  batchRating: "Đánh Giá Lô",
  MakeASelection: "Chọn Một Lựa Chọn",
  typeTotalCoffeeQuantity: "Nhập tổng lượng cà phê",
  typeHumidity: "Nhập độ ẩm",
  valueInPercent: "giá trị %",
  purchaseOrderRequired: "Yêu cầu Đơn Đặt Hàng",
  totalCoffeeCherryRequired: "Yêu cầu Tổng Cà Phê Cherry",
  processTypeRequired: "Yêu cầu Loại Quy Trình",
  stationInfo: "Thông Tin Trạm",
  purchaseOrders: "Đơn Đặt Hàng",
  processingBatch: "Lô Xử Lý",
  processedCoffeeOutRequired: "Yêu cầu Cà phê đã xử lý",
  lotNo: "Số Lô",
  addNewS: "Thêm Mới",
  viewAll: "Xem Tất cả",
  parchmentOut: "Cà phê thóc đầu ra",
  processingDone: "Xử lý Đã Hoàn Tất",
  farmerLotID: "Nông dân và Số Lô",
  weight: "Trọng lượng",
  plantationSettings: "Cài đặt Nông trại",
  PlantationsEachFarmerCanCreate: "Số Nông trại Mỗi Nông dân Có Thể Tạo",
  manageAdditionalPlantationRequests: "Quản lý Yêu cầu Nông trại Bổ sung",
  autoApprove: "Tự động Phê duyệt",
  adminApprovalRequired: "Yêu cầu Phê duyệt từ Quản trị viên",
  close: "Đóng",
  new_user: "Người Dùng Mới",
  KGAcre: "KG/mẫu Anh",

  // Sept 29, 2030
  honey: "Mật ong",
  naturalDry: "Tự nhiên (Khô)",
  wine: "Rượu",
  SemiWashed: "Sơ chế bán ướt",
  fullWashed: "Sơ chế ướt hoàn toàn",
  startDateRequired: "Ngày Bắt đầu là bắt buộc",
  endDateRequired: "Ngày Kết thúc là bắt buộc",
  assigned: "Đã Gán",
  activated: "Đã Kích hoạt",
  unassigned: "Chưa Gán",
  deleteTopic: "Xóa Chủ đề",
  sureToDeleteTopic: "Bạn có chắc muốn xóa chủ đề về vấn đề kỹ thuật không?",
  publishSurvey: "Xuất bản Khảo sát",
  endSurvey: "Kết thúc Khảo sát",
  copy: "Sao chép",
  pending: "Đang Chờ",
  "oma": {
    "fromDate": "Từ ngày",
    "toDate": "Đến ngày",
    "selectDate": "Chọn ngày",
    "cancel": "HỦY",
    "avocadoTreesList": "Danh sách cây bơ",
    "addTreesManually": "Thêm vị trí địa lý cây thủ công",
    "confirmationTitle": "Xác nhận",
    "confirmationMessage": "Cây bơ đã được thêm/sửa thành công",
    "addTreesBulk": "Nhập cây hàng loạt",
    "addNewFarm": "Chọn Trang Trại",
    "selectFarm": "Chọn Trang Trại",
    "selectZone": "Chọn Vùng",
    "treeId": "ID Cây",
    "treeName": "Tên Cây",
    "zoneId": "ID Vùng",
    "latitude": "Vĩ độ",
    "longitude": "Kinh độ",
    "altitude": "Độ cao",
    "timestamp": "Dấu thời gian",
    "avocadoTrees": "Cây Bơ",
    "landSuitibility": "Độ Phù Hợp Của Đất",
    "landSuitibilityReport": "Báo cáo Độ Phù Hợp Của Đất",
    "generateNewReport": "Tạo Báo Cáo Mới",
    "operatorName": "Tên Người Vận Hành",
    "issueDate": "Ngày Phát Hành",
    "chooseYourLocation": "Chọn Vị Trí Của Bạn",
    "getLandEvaluation": "Nhận đánh giá đất",
    "downloadPdfReport": "Tải báo cáo PDF",
    "pleaseEnterCoordinateText": "Vui lòng nhập tọa độ (kinh độ và vĩ độ) của vị trí trang trại để xem điểm số.",
    "noRecordAvailable": "Không có kết quả.",
    "overallScoreForLand": "Điểm Tổng Quát về Độ Phù Hợp Của Đất",
    "landEvaluation": "Đánh Giá Đất",
    "unsuitable": "Không Phù Hợp",
    "marginally": "Hơi Phù Hợp",
    "suitable": "Phù Hợp",
    "moderately": "Tương Đối",
    "highly": "Rất Phù Hợp",
    "back": "Quay Lại",
    "search": "Tìm Kiếm",
    "showResults": "Hiển Thị Kết Quả",
    "weatherAnalysisReport": "Báo cáo Phân Tích Thời Tiết",
    "weatherAnalysis": "Phân Tích Thời Tiết",
    "weatherReport": "Báo cáo Thời Tiết",
    "getWeatherAnalysis": "Nhận Phân Tích Thời Tiết",
    "filterByDate": "Lọc theo Ngày",
    "insertCoordinateText": "Nhập tọa độ của vị trí trang trại (hoặc cây) phía trên hoặc sử dụng bản đồ dưới đây để chỉ định vị trí.",
    "addTreeGeolocation": "Thêm Vị Trí Địa Lý Cây",
    "editTreeGeolocation": "Chỉnh Sửa Vị Trí Địa Lý Cây",
    "plantationDate": "Ngày Trồng",
    "notes": "Ghi Chú",
    "uploadTreeImages": "Tải Hình Ảnh Cây",
    "valueAtTheCoordinatesOfInterest": "Giá trị tại tọa độ quan tâm",
    "Slope (%)": "Độ dốc (%)",
    "Soil texture (USDA class)": "Kết cấu đất (theo phân loại USDA)",
    "Coarse fragments (vol%)": "Các mảnh thô (vol%)",
    "Land": "Đất",
    "Artificial surfaces (type)": "Bề mặt nhân tạo (loại)",
    "Proximity to Type 1 and 2 Roads (meters)": "Khoảng cách đến đường loại 1 và 2 (mét)",
    "Soil Chemical Properties": "Tính Chất Hóa Học Của Đất",
    "Soil Physical Properties": "Tính Chất Vật Lý Của Đất",
    "Soil organic carbon (%)": "Carbon hữu cơ trong đất (%)",
    "Soil pH": "pH Đất",
    "Soil salinity (ECe)": "Độ mặn của đất (ECe)",
    "Mean annual temperature (°C)": "Nhiệt độ trung bình năm (°C)",
    "Weather": "Thời Tiết",
    "Mean minimum temperature of coldest month (°C)": "Nhiệt độ tối thiểu trung bình của tháng lạnh nhất (°C)",
    "Mean annual precipitation (mm)": "Lượng mưa trung bình năm (mm)",
    "avocadoDetailNoUpdates": "Không có cập nhật",
    "avocadoTreeDetail": "Chi Tiết Cây",
    "avocadoTreeDetailHeader": "Chi Tiết Cây Bơ",
    "avocadoTreeUpdates": "Cập Nhật Cây Bơ",
    "avocadoAddImages": "Thêm Hình Ảnh Mới",
    "addNewTreeImage": "Thêm Hình Ảnh Cây Mới",
    "selectCountry": "Chọn Quốc Gia",
    "allRegions": "Tất Cả Các Vùng",
    "avocadoDetailCard": {
      "clientTreeId": "ID Cây",
      "treeName": "Tên Cây",
      "latitude": "Vĩ độ",
      "longitude": "Kinh độ",
      "altitude": "Độ cao",
      "zoneId": "ID Vùng",
      "createdAt": "Ngày & Giờ",
      "plantationDate": "Ngày & Giờ Trồng",
      "updatedAt": "Cập Nhật Cuối Cùng"
    },
    "importCSVFormat": "Nhập Dữ Liệu CSV",
    "importGeoJsonFormat": "Nhập Dữ Liệu GeoJSON",
    "importShapeFilesFormat": "Nhập Dữ Liệu Shape Files",
    "importXLSFormat": "Nhập Dữ Liệu XLS",
    "importGeobufFormat": "Nhập Dữ Liệu Geobuf",
    "importGeoPackageFormat": "Nhập Dữ Liệu GeoPackage",
    "importTopoJsonFormat": "Nhập Dữ Liệu TopoJSON",
    "avocadoTreeDetailsTableHeader": {
      "updatedOn": "Cập Nhật Vào",
      "updatedBy": "Cập Nhật Bởi",
      "notes": "Ghi Chú",
      "noOfImages": "Số Hình Ảnh",
      "actions": "Hành Động"
    },
    "avocadoTreeView": "Xem Cây",
    "avocadoFarmView": "Xem Trang Trại",
    "avocadoTreeDetailPopupTitle": "Xem Chi Tiết Cây",
    "dateOfInterest": "Ngày Quan Tâm",
    "maximumCloudCoverage": "Độ Che Phủ Mây Tối Đa",
    "import": "Nhập Dữ Liệu",
    "history": "Lịch Sử",
    "downloandimport": "Tải Xuống Và Nhập Dữ Liệu",
    "importantNote": "Lưu Ý Quan Trọng",
    "downloadXlsFormat": "Tải Dữ Liệu XLS",
    "downloadCSVFormat": "Tải Dữ Liệu CSV",
    "downloadGeoJSONFormat": "Tải Dữ Liệu GeoJSON",
    "downloadTopoJSONFormat": "Tải Dữ Liệu TopoJSON",
    "downloadGeoPackageFormat": "Tải Dữ Liệu GeoPackage",
    "downloadGeobufFormat": "Tải Dữ Liệu Geobuf",
    "selectXLSFile": "Chọn Tệp XLS",
    "selectCSVFile": "Chọn Tệp CSV",
    "selectGeoJSONFile": "Chọn Tệp GeoJSON",
    "selectTopoJSONFile": "Chọn Tệp TopoJSON",
    "selectGeoPackageFile": "Chọn Tệp GeoPackage",
    "selectGeobufFile": "Chọn Tệp Geobuf",
    "OrDragDrop": "hoặc kéo và thả vào đây",
    "importTrees": "Nhập Cây",
    "importantNoteDetail": "Vui lòng sử dụng các mẫu đã cung cấp ở trên để tải dữ liệu hàng loạt.\nCác định dạng khác sẽ dẫn đến lỗi.",
    "fileName": "Tên Tệp",
    "importedOn": "Đã Nhập Vào",
    "status": "Trạng Thái",
    "actions": "Hành Động",
    "action": "Hành Động",
    "download": "Tải Xuống",
    "removeFile": "Xóa Tệp",
    "importedTrees": "Cây Đã Nhập",
    "geolocation": "Vị Trí Địa Lý",
    "Export CSV Format": "Xuất Dữ Liệu CSV",
    "Export XLSX Format": "Xuất Dữ Liệu XLSX",
    "Export PDF Format": "Xuất Dữ Liệu PDF",
    "noHistoryFound": "Không Tìm Thấy Lịch Sử"
  },
  dueDiligence: {
    question: "Câu hỏi",
    answer: "Câu trả lời",
    noAssessmentWarning: "Báo cáo DDS thiếu các đánh giá rủi ro.",
    listOfFarmsInfo:
    "Hiển thị toàn diện các trang trại, bao gồm thông tin như địa điểm sản xuất, tên nhà sản xuất, quốc gia hoạt động, diện tích đất theo hecta, loại hình canh tác, các đánh giá liên quan đến phá rừng và đánh giá các rủi ro tiềm ẩn liên quan đến hoạt động của trang trại.",

    operatorSelect: "Nhà vận hành: Chọn tùy chọn này nếu bạn, với tư cách là nhà vận hành, sẽ chịu trách nhiệm thêm dữ liệu về nơi sản xuất. Bạn sẽ có tùy chọn cung cấp danh sách nhà sản xuất, trang trại của họ và vị trí địa lý trong ứng dụng.",
    supplierSelect: "Nhà cung cấp: Chọn tùy chọn này nếu nhà cung cấp sẽ chịu trách nhiệm thêm dữ liệu về nơi sản xuất. Họ sẽ có quyền truy cập để cung cấp danh sách nhà sản xuất, trang trại của họ và vị trí địa lý trực tiếp trong ứng dụng.",
    selectWhoWillAddPlaceData: "Chọn ai sẽ thêm dữ liệu về nơi sản xuất",
  
    dueDiligence: "Thẩm định EUDR",
    assementBuilder: "Công cụ tạo đánh giá",
    assessment: "Đánh giá",
    selectUsers: "Chọn người dùng",
    assessmentsList: "Danh sách đánh giá",
    createAssessment: "Tạo đánh giá",
    assessmentName: "Tên đánh giá",
    searchAssessment: "Tìm kiếm đánh giá",
    selectProcess: "Chọn quy trình đánh giá",
    assessSettings: "Cài đặt đánh giá",
    assessmentTitle: "Tiêu đề đánh giá",
    assessDescription: "Mô tả đánh giá",
    describeAsessment: "Mô tả đánh giá",
    country: "Quốc gia",
    selectCountry: "Chọn quốc gia",
    expiryTime: "Thời gian hết hạn",
    noQuestionEachStep: "Số lượng câu hỏi",
    byHeadings: "Theo tiêu đề",
    assessmentStatus: "Trạng thái đánh giá",
    multiStepAssess: "Đánh giá nhiều bước",
    allowAssessment: "Cho phép đánh giá được trả lời nhiều lần",
    onlyIfExpired: "Chỉ khi hết hạn",
    atAnyTime: "Bất kỳ lúc nào",
    editAssessmentDetails: "Chỉnh sửa câu hỏi đánh giá",
    assessmentDetail: "Chi tiết đánh giá",
    addQuestion: "Thêm câu hỏi đánh giá",
    attachFiles: "Đính kèm tệp",
    digitalSignature: "Chữ ký số",
    showChecklist: "Hiển thị danh sách kiểm tra",
    hideChecklist: "Ẩn danh sách kiểm tra",
    fileType: "Loại tệp",
    allowMultipleFile: "Cho phép đính kèm nhiều tệp",
    allowComment: "Cho phép bình luận",
    uploadSignatureFile: "Tải lên tệp chữ ký",
    drawSignature: "Vẽ chữ ký",
    addSubHeading: "Thêm tiêu đề phụ",
    heading: "Tiêu đề",
    subHeading: "Tiêu đề phụ",
    mutiStepHeadingLable: "Tạo bước mới cho mỗi tiêu đề phụ",
    dueDiligenceReports: "Báo cáo thẩm định",
    dueDiligenceReportsInfo: "Tài liệu chi tiết tóm tắt các phát hiện và kết quả của quá trình thẩm định. Các báo cáo này cung cấp cái nhìn sâu sắc về đánh giá đã thực hiện, bao gồm bất kỳ rủi ro nào được xác định, trạng thái tuân thủ và các khuyến nghị về giảm thiểu hoặc cải thiện.",
    logistics: "Vận chuyển",
    editSubHeading: "Chỉnh sửa tiêu đề phụ",
    headingTitle: "Tiêu đề chính",
    partOfOrigin: "Nguồn gốc",
    destination: "Điểm đến",
    addStop: "Thêm điểm dừng",
    stop: "Điểm dừng",
    enterStop: "Nhập điểm dừng",
    shipmentList: "Danh sách lô hàng",
    createShipment: "Tạo lô hàng mới",
    manageFarms: "Quản lý trang trại",
    disputeResolution: "Giải quyết tranh chấp",
    disputeAssessment: "Đánh giá tranh chấp",
    suppliers: "Nhà cung cấp",
    shipments: "Lô hàng",
    dueDiligenceGuide: "Hướng dẫn thẩm định",
    multiStepQuestion1: "Tạo bước mới sau",
    questions: "câu hỏi",
  
    selectRequiredAssessment: 'Chọn đánh giá yêu cầu',
    filterAssessments: "Lọc đánh giá",
    dueDiligenceReportCreation: "Tạo báo cáo thẩm định",
  
    dueDiligenceNew: "Thẩm định mới",
    createNewReport: "Tạo báo cáo mới",
    operator: "Nhà vận hành",
    supplier: "Nhà cung cấp",
    addMoreAssessments: "Thêm nhiều đánh giá",
    internalReferenceNumber: "Số tham chiếu nội bộ",
    referenceNumber: "Số tham chiếu",
    domestic: "Trong nước",
    import: "Nhập khẩu",
    export: "Xuất khẩu",
    selectProduct: "Chọn sản phẩm",
    selectSubProduct: "Chọn sản phẩm phụ",
    addnewSupplier: "Thêm nhà cung cấp mới",
    farmDeforestationReport: "Báo cáo phá rừng trang trại",
  
    addProductionPlaceData: "Thêm dữ liệu nơi sản xuất",
    addProductionPlaceDataTooltip: "Chọn cách bạn muốn thêm dữ liệu",
    addProductionPlaceDataDesc: "Tạo báo cáo của bạn bằng cách tích hợp dữ liệu sản xuất từ nhiều nguồn khác nhau. Chọn một hoặc nhiều nguồn để tổng hợp danh sách các nơi sản xuất cho báo cáo của bạn.",
    dimitraApps: "Ứng dụng Dimitra",
    addNew: "Thêm mới",
    existingData: "Dữ liệu hiện có",
    manualDataEntry: "Nhập dữ liệu thủ công",
    importFile: "Nhập tệp",
    connectedCoffee: "Kết nối Cà phê",
    connectedCacao: "Kết nối Cacao",
    manaulProductionPlace: "Nhập dữ liệu nơi sản xuất thủ công",
    farmerRegistrationId: "Mã đăng ký nông dân",
    farmRegistrationId: "Mã đăng ký trang trại",
    addProductionPlace: "Thêm nơi sản xuất",
    producerName: "Tên nhà sản xuất",
    producerCountry: "Quốc gia sản xuất",
    totalArea: "Tổng diện tích",
    number: "Số",
    productionPlaceDesc: "Mô tả nơi sản xuất",
    area: "Diện tích (ha)",
    type: "Loại",
    actions: "Hành động",
    selectType: "Chọn loại",
    importProductionPlace: "Nhập nơi sản xuất",
    downloadXLSFormat: "TẢI XUỐNG ĐỊNH DẠNG XLS",
    downloadGeoJsonFormat: "Tải xuống định dạng GeoJSON",
    downloadXMLFormat: "Tải xuống định dạng XML",
    downloadFileFormatTemplates: "Tải xuống mẫu định dạng tệp",
    importantNote: "Lưu ý quan trọng",
    pleaseProvideFollowing: "Vui lòng cung cấp theo định dạng sau (GeoJSON và XML)",
    existingProductionPlaces: "Nơi sản xuất hiện có",
    productionPlaceAndFarmID: "Nơi sản xuất & ID trang trại",
  
    selectFileToUploadData: "Chọn tệp để tải dữ liệu lên",
    filterByDate: "Lọc theo ngày",
    dateOfRegister: "Ngày đăng ký",
    dateOfLastReport: "Ngày báo cáo gần nhất",
    clearAll: "Xóa tất cả",
    addLocation: "Thêm vị trí",
  
    pleaseCompleteBeforeProceedingToNext: "Vui lòng hoàn tất phần chi tiết báo cáo trước khi tiếp tục bước tiếp theo.",
    progressSavedSuccessMsg: "Tiến độ đã được lưu thành công!",
    failedSavedProgress: "Không thể lưu tiến độ. Vui lòng thử lại.",
    failedToCreateReportDetails: "Không thể tạo chi tiết báo cáo. Vui lòng thử lại.",
    unExpectedErrorMsg: "Đã xảy ra lỗi không mong muốn. Vui lòng thử lại.",
    selectAssessment: "Chọn đánh giá",
    confirmationPopup: "Popup xác nhận",
    confirmation: "Xác nhận",
    saveAndConfirmationMessage: "Bạn có chắc chắn muốn lưu các thay đổi không?",
    supplierNotRegisterContent: "Nhà cung cấp chưa đăng ký. Bạn có muốn gửi thông báo cho nhà cung cấp để tham gia nền tảng qua email không?",
  
    confirmationPopupMsg: "Bạn có chắc chắn muốn hủy bỏ báo cáo này không? Xác nhận hành động này sẽ dẫn đến việc xóa vĩnh viễn.",
    warningPopup: "Popup cảnh báo",
    warningPopupMsg: "Bạn có chắc chắn muốn từ chối báo cáo này không? Lưu ý: Dữ liệu báo cáo này sẽ được lưu sau khi từ chối để bạn có thể xem lại sau.",
    automatedDeforestationProgressText: "Kiểm tra phá rừng tự động của dữ liệu hàng rào địa lý và xác định các trường hợp quan trọng",
    someRiskWereIdentifiedText: "Một số rủi ro đã được xác định trong trang trại sau, bạn nên xem xét trang trại với các rủi ro đã được xác định và giảm thiểu chúng trước khi chuyển sang bước tiếp theo.",
  
    riskAssessmentAndMitigation: "Đánh giá và giảm thiểu rủi ro",
    riskAssessmentStatus: "Trạng thái đánh giá rủi ro",
    riskAssessment: "Đánh giá rủi ro",
    uploadRiskAssessment: "Tải lên đánh giá rủi ro",
    manualFillOutAssessment: "Điền đánh giá thủ công",
    downloadDeforestationAssessmentTemplate: "Tải xuống mẫu đánh giá phá rừng",
    submit: "Gửi",
    noRiskIdentified: "Không có rủi ro nào được xác định",

    myFarms: "Trang trại của tôi",
  },  
  deforestation: {
    riskLevel: "Rủi ro",
    selectFileToUpload: "Chagua faili kupakia data",
    "Zero/Negligible Deforestation Probability": "Xác suất phá rừng bằng không/không đáng kể",
    "Zero Deforestation Probability": "Xác suất phá rừng bằng không",
    "Low Deforestation Probability": "Xác suất phá rừng thấp",
    "High Deforestation Probability": "Xác suất phá rừng cao",
    "Very Low Deforestation Probability": "Xác suất phá rừng rất thấp",
    "Medium Deforestation Probability": "Xác suất phá rừng trung bình",
    "Very High Deforestation Probability": "Xác suất phá rừng rất cao",
    disputeReason: "Lý do tranh chấp",
    disputeStatus: "Trạng thái tranh chấp",
    farmRegId: "Mã đăng ký trang trại",
    productionPlaceId: "Mã nơi sản xuất",
    disputeId: "Mã tranh chấp",
    disputeArea: "Diện tích tranh chấp",
    disputeResolution: "Giải quyết tranh chấp",
    deforestationComplianceReport: "Báo cáo tuân thủ phá rừng",
    noDeforestationComplianceReport: "Không tìm thấy báo cáo tuân thủ phá rừng",
    loadingDeforestationComplianceReport: "Đang tải báo cáo tuân thủ phá rừng",
    farmName: "Tên trang trại",
    farmRegistrationId: "Mã đăng ký trang trại",
    farmerName: "Tên nông dân",
    farmerRegistrationId: "Mã đăng ký nông dân",
    uniqueFarmerId: "Mã nông dân duy nhất",
    uniqueFarmId: "Mã trang trại duy nhất",
    farmLocation: "Vị trí trang trại",
    area: "Diện tích",
    farmAddress: "Địa chỉ trang trại",
    dateOfRequest: "Ngày yêu cầu",
    status: "Trạng thái",
    settings: "Cài đặt",
    selectDefaultMeasurementUnit: "Chọn đơn vị đo lường mặc định",
    maxLimit: "Giới hạn tối đa",
    asDefault: "Đánh dấu là mặc định",
    productMass: "Khối lượng sản phẩm",
    unit: "Đơn vị",
    userType: "Loại người dùng",
    eudrPortalApiKeys: "Khóa API cổng EUDR",
    apiKey: "Khóa API",
    apiSecret: "Bí mật API",
    assessmentRiskMitigationLvl: "Mức giảm thiểu rủi ro đánh giá",
    deforestationAssessmentRiskToleranceLevel: "Mức độ chịu đựng rủi ro đánh giá phá rừng",
    dynamicExpiryTime: "Thời gian hết hạn động",
    eudrDeforestationAssessment: "Đánh giá phá rừng EUDR",
    autoRenewalIf: "Tự động gia hạn khi thêm vào báo cáo thẩm định",
    declarationStatements: "Tuyên bố",
    filterDeclaration: "Lọc tuyên bố",
    declarationTitle: "Tiêu đề tuyên bố",
    applicableCountry: "Các quốc gia áp dụng",
    addMore: "Thêm nữa",
    autoRenewal: "Tự động gia hạn",
    createNewAssessment: "Tạo đánh giá mới",
    userDimitraAssessment: "Sử dụng đánh giá Dimitra",
    shipmentList: "Danh sách lô hàng",
    generalData: "Dữ liệu chung",
    check: "Kiểm tra",

    eudrComplianceStatus: "Trạng thái tuân thủ EUDR",
    farmLatitude: "Vĩ độ trang trại",
    farmLongitude: "Kinh độ trang trại",
    shareQRCode: "Chia sẻ mã QR",
    copy: "Sao chép",

    allCountries: "Tất cả các quốc gia",
    allRegions: "Tất cả các khu vực",
    allFarms: "Tất cả các trang trại",
    allProducer: "Tất cả các nhà sản xuất",
    viewCertificate: "Xem chứng chỉ",

    assignmentIssued: "Nhiệm vụ đã phát hành",

    complianceCertification: "Chứng nhận tuân thủ",
    noComplianceCertification: "Không tìm thấy chứng nhận tuân thủ",
    loadingComplianceCertification: "Đang tải chứng nhận tuân thủ",

    eudrForestAssessment: "Đánh giá rừng EUDR",
    assessmentReport: "Báo cáo đánh giá",
    downloadPDF: "Tải PDF",
    back: "Quay lại",
    farmDetails: "Chi tiết trang trại",

    dimitraFarmId: "Mã trang trại Dimitra",
    dimitraFermerId: "Mã nông dân Dimitra",
    totalGeofenceAreaHA: "Tổng diện tích hàng rào địa lý (AC)",
    forestLossHA: "Mất rừng (AC)",
    forestGainHA: "Tăng rừng (AC)",
    forestUnchangedHA: "Rừng không thay đổi (AC)",
    shareCertificate: "Chia sẻ chứng chỉ",
    forestUnchanged: "Rừng không thay đổi",
    forestLoss: "Mất rừng",
    forestGain: "Tăng rừng",
    totalGeofenceArea: "Tổng diện tích hàng rào địa lý",
    print: "In",
    deforestationProbability: "Xác suất phá rừng",
    colorCode: "Mã màu",
    geofenceArea: "Diện tích hàng rào địa lý",
    percentageOfGeofenceArea: "Tỷ lệ diện tích hàng rào địa lý",
    view: "Xem",
    customization: "Tùy chỉnh",
    recordsPerpage: "Số bản ghi mỗi trang",
    restoreDefault: "Khôi phục mặc định",
    apply: "Áp dụng",
    forestAssessmentHelp: "Nếu bạn có câu hỏi về báo cáo này hoặc cần trợ giúp để hiểu nó, hãy liên hệ với chúng tôi qua bàn trợ giúp.",
    overallDeforestationProbability: "Xác suất phá rừng tổng thể",
    zeroOrNeglegible: "Bằng không hoặc không đáng kể",
    very_high: "Rất cao",
    medium: "Trung bình",
    high: "Cao",
    allStatus: "Tất cả trạng thái",
    low: "Thấp",
    very_low: "Rất thấp",
    assessmentIssued: "Đánh giá đã phát hành",
    certificateIssued: "Chứng chỉ đã phát hành",
    assessmentNo: "Số đánh giá",
    blockchainCertificateDesc: "Mã xác thực chứng chỉ blockchain sẽ có sẵn khi chấp nhận chứng chỉ",
    blockchainValidation: "Xác thực chứng chỉ blockchain",
    openBlockchainPage: "Mở trang blockchain",
    clickLinkDesc: "Nhấp vào liên kết trên để xác thực chứng chỉ trên blockchain",
    zeroOrNegligible: "Bằng không/không đáng kể",
    veryHigh: "Rất cao",
    veryLow: "Rất thấp",
    tooltip: {
      dimitraFarmId: "Mã định danh duy nhất liên kết với một trang trại cụ thể trong hệ thống Dimitra.",
      farmName: "Tên được chỉ định của trang trại.",
      farmRegistrationId: "Số đăng ký của trang trại.",
      farmLocation: "Tọa độ địa lý cụ thể hoặc vị trí của trang trại.",
      dimitraFermerId: "Mã định danh riêng biệt liên kết với một nông dân trong hệ thống Dimitra.",
      farmerName: "Tên của người chịu trách nhiệm cho trang trại.",
      farmerRegistrationId: "Số đăng ký của nông dân.",
      assessmentNo: "Số duy nhất được gán cho đánh giá."
    },
    darkRed: "Đỏ đậm",
    red: "Đỏ",
    Yellow: "Vàng",
    Orange: "Cam",
    lightBlue: "Xanh nhạt",
    teal: "Xanh lam",
    transparent: "Trong suốt",
    zeroOrNeglegibleProbability: "Xác suất phá rừng bằng không/không đáng kể",
    brightRed: "Đỏ sáng",
    orange: "Cam",
    zeroOrNegligibleProbability: "Xác suất phá rừng bằng không/không đáng kể",
    riskDetected: "Rủi ro được phát hiện",
    zeroOrNegligibleRisk: "Không có/Rủi ro không đáng kể",
        manuallyMitigated: "Giảm thiểu thủ công",
    compliant: "Tuân thủ",
    nonCompliant: "Không tuân thủ",
    veryLowProbability: "Xác suất phá rừng rất thấp",
    lowProbability: "Xác suất phá rừng thấp",
    mediumProbability: "Xác suất phá rừng trung bình",
    highProbability: "Xác suất phá rừng cao",
    veryHighProbability: "Xác suất phá rừng rất cao",
    locationName: "Tên địa điểm",
   
    approve: "Phê duyệt",
    approveMessage: "Bạn có chắc chắn muốn chấp thuận báo cáo này không? Bằng cách chấp thuận báo cáo này, báo cáo sẽ được tải vĩnh viễn lên blockchain. Một liên kết blockchain và mã QR sẽ được tạo và không thể thực hiện thêm bất kỳ cập nhật hoặc chỉnh sửa nào nữa. Bạn có muốn tiếp tục không?",
    dueDeligence: "Thẩm định",
    supplierInformation: "Thông tin nhà cung cấp",
    addNewSupplier: "Thêm nhà cung cấp mới",
    name: "Tên",
    lastName: "Họ",
    email: "Email",
    phoneNumber: "Số điện thoại",
    enterSupplierName: "Nhập tên nhà cung cấp",
    enterSupplierFirstName: "Nhập tên nhà cung cấp",
    enterSupplierLastName: "Nhập họ nhà cung cấp",
    enterOperatorName: "Nhập tên nhà vận hành",
    enterEmailAddress: "Nhập địa chỉ email",
    enterPhoneNumber: "Nhập số điện thoại",
    whoWillAddPlace: "Ai sẽ thêm dữ liệu nơi sản xuất?",
    companyId: "Mã công ty",
    activity: "Hoạt động",
    placeOfActivity: "Nơi hoạt động",
    countryOfActivity: "Quốc gia hoạt động",
    countryOfEntry: "Quốc gia nhập cảnh",
    productDetail: "Chi tiết sản phẩm",
    subProduct: "Sản phẩm phụ",
    productionDescription: "Mô tả sản phẩm",
    netMass: "Khối lượng tịnh",
    volume: "Thể tích",
    scietificName: "Tên khoa học",
    commonName: "Tên thông thường",
    eudrDueDeligenceReports: "Báo cáo thẩm định EUDR",
    EUDRAssessmentReport: "Báo cáo đánh giá EUDR",
    createNewReport: "Tạo báo cáo mới",
    eudrRefNo: "Số tham chiếu EUDR",
    internalRefNo: "Số tham chiếu nội bộ",
    supplier: "Nhà cung cấp",
    eoriNumber: "Số EORI",
    isoCode: "Mã ISO",
    operator: "Nhà điều hành",
    quantity: "Số lượng",
    product: "Sản phẩm",
    noOfFarms: "Số lượng trang trại",
    farmsAndQuantity: "Nông trại và Số lượng",
    country: "Quốc gia",
    lastUpdated: "Cập nhật lần cuối",
    dueDeligenceStatus: "Trạng thái thẩm định",
    reject: "Từ chối",
    discard: "Loại bỏ",
    saveAndContinueLater: "Lưu và tiếp tục sau",
    requestAdditionalInformation: "Yêu cầu thêm thông tin",
    requestAdditionalInformationShort: "Yêu cầu thêm thông tin",
    uploadToEudr: "Tải lên EUDR",
    productionPlaces: "Nơi sản xuất",
    next: "Tiếp theo",
    dueDeligenceReportCreation: "Tạo báo cáo thẩm định",
    producer: "Nhà sản xuất",
    select: "Chọn",
    productionPlacesFarmAndFarmId: "Nơi sản xuất (Trang trại) & mã trang trại",
    producerName: "Tên nhà sản xuất",
    addressOfProduction: "Địa chỉ sản xuất",
    type: "Loại",
    geofence: "Hàng rào địa lý",
    areaHa: "Diện tích (ha)",
    editGeofence: "Chỉnh sửa hàng rào địa lý",
    totals: "Tổng cộng",
    locationVerification: "Xác minh vị trí",
    AnalysisOfDeforestationStatus: "Phân tích trạng thái phá rừng",
    EUDRDeforestationStatus: "Trạng thái phá rừng EUDR",
    removeAllLowRiskFarm: "Loại bỏ tất cả các trang trại rủi ro thấp",
    removeAllHighRiskFarm: "Loại bỏ tất cả các trang trại rủi ro cao",
    removeAllMediumRiskFarm: "Loại bỏ tất cả các trang trại rủi ro trung bình",
    attachRiskMigrationDoc: "Đính kèm một tài liệu giảm thiểu rủi ro cho tất cả các trang trại rủi ro cao",
    removedFarms: "Các trang trại đã bị loại bỏ khỏi danh sách",
    generateCertificate: "Tạo chứng chỉ",
    viewDisputeHistory: "Xem lịch sử tranh chấp",
    disputeAssessment: "Đánh giá tranh chấp",
    reportDetails: "Chi tiết báo cáo",
    productionPlace: "Nơi sản xuất",
    EUDRDeforestationAssessment: "Đánh giá phá rừng EUDR",
    EUDRcountry: "Quốc gia nơi trang trại tọa lạc, được liên kết với sản phẩm trong báo cáo thẩm định. Nó hỗ trợ đảm bảo khả năng truy xuất nguồn gốc theo địa lý theo yêu cầu của các quy định EUDR.",
    riskAssessment: "Đánh giá rủi ro",
    legalInformation: "Thông tin pháp lý",
    finalReport: "Báo cáo cuối cùng",
    editGeolocation: "Chỉnh sửa vị trí địa lý",
    producerCountry: "Quốc gia sản xuất",
    manuallyAddData: "Thêm dữ liệu thủ công",
    drawGeofence: "Vẽ hàng rào địa lý",
    uploadFile: "Tải tệp lên",
    typeyourlocation: "Nhập tên/vị trí địa chỉ của bạn",
    numberOfPoints: "Số điểm đa giác",
    viewGeolocation: "Xem vị trí địa lý",
    geoLocation: "Vị trí địa lý",
    Point: "Điểm",
    Polygon: "Đa giác",
    selectFileToUploadData: "Chọn tệp để tải dữ liệu lên",
    loadingProductionPlaces: "Đang tải nơi sản xuất",
    remove: "Loại bỏ",
    restore: "Khôi phục",

    riskMitigation: "Giảm thiểu rủi ro",
    assessmentRiskMitigation: "Giảm thiểu rủi ro đánh giá",

    submissionDate: "Ngày nộp",
    eudrReferenceNo: "Số tham chiếu EUDR",
    internalReferenceNo: "Số tham chiếu nội bộ",
    exporter: "Nhà xuất khẩu",
    importer: "Nhà nhập khẩu",
    shipmentReferenceNo: "Số tham chiếu lô hàng",
    ownerShipType: "Loại sở hữu",
    buyer: "Người mua",
    buyerName: "Tên người mua",
    port_of_origin: "Cảng xuất phát",
    port_of_destination: "Cảng đích",
    no_of_stops: "Số điểm dừng",
    shipping_line: "Hãng tàu",
    expected_arrival_date: "Ngày dự kiến đến",
    container_id: "Mã container",
    container_type: "Loại container",
    container_size: "Kích thước container (ft)",
    container_capacity: "Dung tích container (tấn)",
    eudr_reference_number: "Số tham chiếu EUDR",
    actions: "Hành động",
  },
  farm: {
    iAmNotFarmer: "Tôi không phải là Nông dân",
    personal: "Cá nhân",
    community: "Cộng đồng",
    searchEvents: "Tìm kiếm sự kiện",
    farmerId: "ID nông dân",
    farmAddress: "Địa chỉ vị trí trang trại",
    farmID: "ID trang trại",
    farmIdPlaceHolder: "Nhập ID trang trại",
    onTheFarm: "Trên trang trại",
    userRoles: "Vai trò người dùng",
    adduser: "Thêm người dùng",
    addAuser: "Thêm một người dùng",
    uploadUsers: "Tải lên người dùng",
    addNewUser: "Thêm người dùng mới",
    selectDept: "Chọn phòng ban",
    selectRole: "Chọn vai trò",
    editUser: "Chỉnh sửa người dùng",
    totalFarms: "Tổng số trang trại",
    NoAnimalsRegisteredForthisFarm: "Không có động vật nào được đăng ký cho trang trại này",
    farmsPerPage: "Trang trại mỗi trang",
    regularFarms: "Trang trại thông thường",
    farmRegisteredProducts: "Sản phẩm đã đăng ký của trang trại",
    searchByFarmNameAndId: "Tìm kiếm theo tên và ID trang trại",
    loadingProductsPleaseWait: "Đang tải sản phẩm... Vui lòng đợi",
    farmName: "Tên trang trại",
    nameOfTheFarm: "Tên của trang trại",
    farmLocation: "Vị trí trang trại",
    productName: "Tên sản phẩm",
    stockStatus: "Tình trạng kho",
    inStock: "Còn hàng",
    searchByProductName: "Tìm kiếm theo tên sản phẩm",
    productCategory: "Danh mục sản phẩm",
    products: "Sản phẩm",
    farms: "Trang trại",
    zones: "Khu vực",
    registerAfarm: "Đăng ký một trang trại",
    govtRegistry: "Đăng ký chính phủ",
    cooperativeId: "ID hợp tác xã/liên minh",
    cooperativeName: "Tên hợp tác xã/liên minh",
    farmType: "Loại trang trại",
    contractMating: "Giao phối hợp đồng",
    customization: "Tùy chỉnh",
    recordsPerpage: "Bản ghi mỗi trang",
    restoreDefault: "Khôi phục mặc định",
    apply: "Áp dụng",
    CommunityName: "Tên cộng đồng",
    corporateName: "Tên công ty",
    corporateRegistrationNum: "Số đăng ký công ty",
    corporateMailingAddress: "Địa chỉ gửi thư công ty",
    communityName: "Tên cộng đồng",
    searchState: "Tìm kiếm theo ID trang trại, đăng ký chính phủ, ID hợp tác xã, loại trang trại, giao phối hợp đồng",
    farmOwner: "Chủ trang trại",
    govRegistrationNo: "Số đăng ký chính phủ",
    farmInformation: "Thông tin trang trại",
    ownershipType: "Loại sở hữu",
    farmLicenseInformation: "Thông tin giấy phép trang trại",
    licenseNumber: "Số giấy phép",
    licenseExpiryDate: "Ngày hết hạn giấy phép",
    regulatorName: "Tên cơ quan quản lý",
    regulatorRepresentativeName: "Tên đại diện cơ quan quản lý",
    farmLocationSize: "Vị trí & kích thước trang trại",
    productionSystem: "Hệ thống sản xuất",
    productionSystemNew: "Hệ thống sản xuất",
    goals: "Mục tiêu",
    country: "Quốc gia",
    state: "Bang",
    city: "Làng/Thị trấn/Thành phố",
    gpsLocation: "Vị trí GPS",
    latitude: "Vĩ độ",
    longitude: "Kinh độ",
    farmNumber: "Số trang trại",
    postal: "Mã bưu điện",
    houseNumber: "Số nhà",
    farmRegistration: "Đăng ký trang trại",
    cancel: "Hủy bỏ",
    register: "Đăng ký",
    ok: "OK",
    totalFarmSize: "Tổng kích thước trang trại",
    farmGeographicLocation: "Vị trí địa lý trang trại",
    perimeterPointLongitude: "Kinh độ điểm chu vi",
    perimeterPointLatitude: "Vĩ độ điểm chu vi",
    perimeterPointLabel: "Nhãn điểm chu vi",
    perimeterLength: "Chiều dài chu vi",
    farmLatitude: "Vĩ độ trang trại",
    farmLongitude: "Kinh độ trang trại",
    editFarm: "Chỉnh sửa trang trại",
    update: "Cập nhật",
    editAfarm: "Chỉnh sửa một trang trại",
    nextFarm: "Trang trại tiếp theo",
    nameoftheFarm: "Tên của trang trại",
    addNewLocation: "Thêm vị trí mới",
    registerAProduct: "Đăng ký một sản phẩm",
    farmProducts: "Sản phẩm trang trại",
    calf: "Bê",
    steer: "Bò đực thiến",
    heifer: "Bò cái tơ",
    sire: "Bò đực giống",
    dam: "Bò cái giống",
    registerAnAnimal: "Đăng ký một động vật",
    farmAnimals: "Động vật trang trại",
    farm_type: "Loại trang trại",
    farm_Owner: "Chủ trang trại",
    dateOfRegistration: "Ngày đăng ký",
    dataIsNotAvailableForThisFarm: "Dữ liệu không có sẵn cho trang trại này",
    registerNewProduct: "Đăng ký một sản phẩm mới",
    information: "Thông tin",
    licenseInfo: "Thông tin giấy phép",
    locationInfo: "Thông tin vị trí",
    geoLocation: "Vị trí địa lý",
    perimeterLengthState: "Chiều dài chu vi trang trại (chiều dài hàng rào)",
    totalFarmSizeState: "Kích thước của một trang trại",
    productionSystemState: "Hệ thống sản xuất được sử dụng trong trang trại",
    contractMatingState: "Mã chương trình giao phối hợp đồng mà trang trại tham gia.",
    ownershipTypeState: "Loại sở hữu",
    regulatorRepresentativeNameState: "Tên của người đại diện cơ quan quản lý đã cấp giấy phép",
    regulatorNameState: "Tên cơ quan quản lý đã cấp giấy phép",
    licenseExpiryDateState: "Ngày hết hạn giấy phép hiện tại",
    licenseNumberState: "Số giấy phép do cơ quan quản lý cấp",
    plotNumberState: "Số nhà của trang trại.",
    plotNumber: "Số trang trại",
    streetStatement: "Tên đường của trang trại.",
    cityStatement: "Thành phố nơi trang trại tọa lạc.",
    farmLocationAddressInfo: "Nơi trang trại thực hiện hoạt động nông nghiệp chính của mình.",
    provinceStateInfo: "Một đơn vị hành chính chủ yếu của một quốc gia hoặc đế chế.",
    cityInfo: "Một khu định cư hoặc cộng đồng tập trung của con người và các tòa nhà liên quan, lớn hơn một thôn và nhỏ hơn một thị trấn, nằm ở khu vực nông thôn.",
    streetNumberInfo: "Số đường",
    totalFarmSizeInfo: "Tổng kích thước trang trại",
    areaUOMInfo: "Đơn vị đo lường kích thước trang trại, ví dụ: Hecta, Acre, v.v.",
    perimeterLengthInfo: "Tổng chu vi trang trại",
    permiterUOMInfo: "Đơn vị đo lường chu vi trang trại, ví dụ: Centimet, Mét, v.v.",
    stateStatement: "Khu vực của quốc gia nơi trang trại tọa lạc.",
    countryState: "Quốc gia nơi trang trại tọa lạc.",
    farmStateInfo: "Địa chỉ vị trí trang trại",
    perimeterPointLongitudeState: "Kinh độ của một điểm trên trang trại.",
    perimeterPointLatitudeState: "Vĩ độ của một điểm trên trang trại.",
    perimeterPointLabelState: "Nhãn của điểm.",
    farmLongitudeState: "Kinh độ của trang trại.",
    farmLatitudeState: "Vĩ độ của trang trại.",
    deleteFarm: "Xóa trang trại",
    farmNameH: "Tên trang trại",
    farmTypeH: "Loại trang trại nơi các hoạt động khác nhau được thực hiện.",
    farmOwnerH: "Tên chủ trang trại (tự động tạo tên nông dân khi nhập thông tin)",
    ownershipTypeH: "Loại nông dân sở hữu/kiểm soát đất họ canh tác và những người không sở hữu.",
    govtRegNumbH: "Số đăng ký của trang trại được cơ quan quản lý cấp",
    contractMatingH: "Mã chương trình giao phối hợp đồng mà trang trại tham gia",
    productionSystemH: "Hệ thống sản xuất được sử dụng trên trang trại",
    cooperativeIDH: "ID của hợp tác xã mà trang trại là thành viên",
    licenseNumberH: "Số giấy phép do cơ quan quản lý cấp xác định nó với chủ sở hữu.",
    licenseExpiryDateH: "Ngày hết hạn giấy phép hiện tại",
    regularNameH: "Tên cơ quan quản lý đã cấp giấy phép",
    regularRepName: "Tên của người đại diện cơ quan quản lý đã cấp giấy phép",
    countryH: "Quốc gia nơi trang trại tọa lạc.",
    stateH: "Khu vực của quốc gia nơi trang trại tọa lạc.",
    cityH: "Thành phố nơi trang trại tọa lạc.",
    streetH: "Tên đường của trang trại.",
    houseNumberH: "Số nhà của trang trại.",
    totalFarmSizeH: "Kích thước trang trại là tổng diện tích đất hiện đang được canh tác bởi trang trại bao gồm đất bỏ hoang nhưng không bao gồm đất dưới thảm thực vật tự nhiên, cây cối hoặc đồng cỏ.",
    farmLatitudeH: "Là phép đo khoảng cách về phía bắc hoặc phía nam của đường xích đạo. Nó được đo bằng 180 đường tưởng tượng tạo thành các vòng tròn quanh Trái đất theo hướng đông-tây, song song với đường xích đạo",
    farmLongitudeH: "Nó đo khoảng cách về phía đông hoặc phía tây của kinh tuyến gốc.",
    perimeterLengthH: "Chiều dài chu vi trang trại (chiều dài hàng rào)",
    perimeterPointLabelH: "Nhãn của điểm. Sử dụng ba tham số (vĩ độ, kinh độ và nhãn) chúng tôi mô tả chu vi của trang trại và bất kỳ đoạn nào bên trong trang trại.",
    perimeterPointLatH: "Vĩ độ của một điểm trên trang trại",
    perimeterPointLongH: "Kinh độ của một điểm trên trang trại",
    street: "Đường",
    registration: {
      regulatorName: "Tên cơ quan quản lý đã cấp giấy phép",
      perimeterPointLabel: "Nhãn của điểm. Sử dụng ba tham số (vĩ độ, kinh độ và nhãn) chúng tôi mô tả chu vi của trang trại và bất kỳ đoạn nào bên trong trang trại.",
      perimeterPointLatitude: "Vĩ độ của một điểm chu vi",
      perimeterPointLongitude: "Kinh độ của một điểm chu vi",
      farmID: "Số nhận dạng được cấp cho trang trại chăn nuôi",
      farmName: "Tên được đặt cho trang trại chăn nuôi",
      CommunityName: "Tên được đặt cho một nhóm người có đặc điểm hoặc sở thích chung sống cùng nhau trong một xã hội lớn hơn",
      farmType: "Loại trang trại có thể được phân loại (nhóm) theo loại gia súc được nuôi và cách nuôi",
      farmOwner: "Bất kỳ người nào sở hữu hoặc kiểm soát các hoạt động của một trang trại",
      ownershipType: "Loại nông dân sở hữu/kiểm soát trang trại và những người không sở hữu",
      govtRegistrationNumber: "Số được cấp bởi tổ chức chính phủ nơi trang trại đăng ký",
      licenseNumber: "Số giấy phép do cơ quan quản lý cấp",
      licenseExpiryDate: "Ngày giấy phép trở nên không hợp lệ để công nhận",
      regulatorRepresentativeName: "Tên của đại diện cơ quan quản lý"
    },
    addFarm: "Thêm trang trại",
    importFarmsInBulk: "Nhập trang trại hàng loạt",
    importFarms: "Nhập trang trại",
    importingNote:
      "Tệp tải lên của bạn hiện đang được xử lý.\nĐừng nhấp vào hủy, đóng hoặc làm mới trang này để tránh gián đoạn.",
    bulkImportNote:
      "Tải xuống và sử dụng các mẫu dưới đây để nhập trang trại hàng loạt.",
    importCompleted: "Nhập hoàn tất",
    farmerFirstName: "Tên đầu tiên của nông dân",
    farmerMiddleName: "Tên đệm của nông dân",
    farmerLastName: "Họ của nông dân",
    certifications: "Chứng nhận",
    productionType: "Loại sản xuất",
    deleted: "Trang trại đã được xóa thành công.",
    notDeleted: "Trang trại không được xóa.",
    farmTitleDocument: "Tài liệu tiêu đề trang trại",
    dropHere: "hoặc kéo và thả vào đây",
    technicianName: "Tên kỹ thuật viên",
    farmRegistrationId: "ID đăng ký trang trại",
    farmerRegistrationId: "ID đăng ký nông dân",
    farmId: "ID trang trại",
    farmerName: "Tên nông dân",
    farmOwnershipType: "Loại sở hữu trang trại",
    farmGoals: "Mục tiêu trang trại",
    farmCertifications: "Chứng nhận trang trại",
    farmInfo: "Thông tin trang trại",
    provinceState: "Tỉnh/Bang",
    streetNumber: "Số đường",
    addGeofenceForThisFarm: "Thêm hàng rào địa lý cho trang trại này",
    pleaseClickToChooseLocation: "Vui lòng nhấp để chọn vị trí",
    address: "Địa chỉ",
    geographicLocation: "Vị trí địa lý",
    searchLocation: "Tìm kiếm vị trí",
    pleaseChooseOneOfTheOption: "Vui lòng chọn một trong các tùy chọn",
    useGeoFencingFeature: "Sử dụng tính năng hàng rào địa lý",
    uploadShapeFile: "Tải lên tệp hình dạng",
    uploadGeofence: "Tải lên hàng rào địa lý",
    upload: "Tải lên",
    reports: "Báo cáo",
    avocado: "Bơ",
    avocadoTrees: "Cây bơ",
    addNewFarmLocation: "Thêm vị trí trang trại mới",
    farmLocationAddress: "Địa chỉ vị trí trang trại",
    useGeofenceTool: "Sử dụng công cụ hàng rào địa lý",
    geofenceIsRequiredForSatelliteReport:
      "Lưu ý: Hàng rào địa lý là bắt buộc cho các báo cáo vệ tinh",
    enterHere: "Nhập vào đây",
    primaryLocation: "Vị trí chính",
    secondaryLocation: "Vị trí phụ",
    locationAndSize: "Vị trí và kích thước",
    farmReports: "Báo cáo",
    activities: "Hoạt động",
    search: "Tìm kiếm",
    selectCountry: "Chọn quốc gia",
    filterByFarmName: "Lọc theo tên trang trại",
    filterByCropType: "Lọc theo loại cây trồng",
    filterByStartDate: "Lọc theo ngày bắt đầu",
    download: "Tải xuống",
    of: "của",
    previousPage: "Trang trước",
    nextPage: "Trang tiếp theo",
    view: "Xem",
    activityDetails: "Chi tiết hoạt động",
    activity: "Hoạt động",
    cropType: "Loại cây trồng",
    startDate: "Ngày bắt đầu",
    endDate: "Ngày kết thúc",
    description: "Mô tả",
    close: "Đóng",
    farmActivities: "Hoạt động trang trại",
    listView: "Chế độ xem danh sách",
    calendarView: "Chế độ xem lịch",
    scheduledActivities: "Hoạt động đã lên lịch",
    completedActivities: "Hoạt động đã hoàn thành",
    deforestationReports: "Báo cáo phá rừng",
    id: "ID",
    locationName: "Tên vị trí",
    createdAt: "Được tạo vào",
    etherScanLink: "Liên kết Blockchain",
    overallProb: "Xác suất tổng thể",
    addNewZone: "Thêm khu vực mới",
    noZoneMessage: "Chưa có khu vực nào được đăng ký.",
    noZoneRequest:
      "Vui lòng nhấp vào Thêm khu vực mới để tạo khu vực cho trang trại này.",
    locationZone: "Khu vực vị trí",
    editFarmLocation: "Chỉnh sửa vị trí trang trại",
    addZone: "Thêm khu vực",
    nameOfTheZone: "Tên của khu vực",
    zoneDetails: "Chi tiết khu vực",
    perimeter: "Chu vi",
    areaUnit: "Đơn vị diện tích",
    area: "Diện tích",
    zoneName: "Tên khu vực",
    farmGeofence: "Hàng rào địa lý trang trại",
    circularGeofence: "Hàng rào địa lý hình tròn",
    polygonGeofence: "Hàng rào địa lý hình đa giác",
    radius: "Bán kính",
    actions: "Hành động",
    editZone: "Chỉnh sửa khu vực",
    numberOfGroups: "Số lượng nhóm",
    numberOfTrees: "Số lượng cây",
    group: "Nhóm",
    groupName: "Tên nhóm",
    numberOfAnimals: "Số lượng động vật",
    status: "Trạng thái",
    primaryGeofence: "Hàng rào địa lý chính",
    walkAndMeasure: "Đi bộ và đo lường",
    clearGeofence: "Xóa hàng rào địa lý",
    deleteSelectedVertex: "Xóa đỉnh đã chọn",
    basicInformation: "Thông tin cơ bản",
    geofenceCategoryName: "Tên danh mục hàng rào địa lý",
    geofenceName: "Tên hàng rào địa lý",
    farmRadius: "Bán kính trang trại",
    locationDisabledMessage:
      "Vị trí của bạn đã bị vô hiệu hóa. Vui lòng tìm kiếm vị trí của bạn từ các menu bên trái.",
    yourDistanceIs: "Khoảng cách của bạn là",
    selectFarmToEnableCalendarView: 'Vui lòng chọn một trang trại để bật chế độ xem lịch',
  },
  exportAs: "xuất khẩu như",
  buySell: {
    farmerName: "Tên Nông Dân",
    location: "Vị Trí",
    country: "Quốc Gia",
    gender: "Giới Tính",
    noOfOrdersSold: "Số Lượng Đơn Hàng Đã Bán",
    noOfPurchaseOrders: "Số Lượng Đơn Hàng Mua",
    totalPurchaseSaleVolume: "Tổng Khối Lượng Mua/Bán",
    totalAvgValue: "Giá Trị Trung Bình Tổng Cộng",
    searchOrderByID: "Tìm Kiếm Đơn Hàng Theo ID",
    totalNumberofOrders: "Tổng Số Đơn Hàng",
    totalNumberOfTransactions: "Tổng Số Giao Dịch",
    totalWeightOfTransactions: "Tổng Trọng Lượng Giao Dịch",
    totalMonetaryValue: "Tổng Giá Trị Tiền Tệ",
    averagePriceperKg: "Giá Trung Bình Mỗi Kg",
  }, 
  hideLogo: "Ẩn Logo",
  hideSplash: "Ẩn Splash",
  remove: "Loại bỏ",
  version: "Phiên bản",
  'Day/s': 'Ngày',
  'Month/s': 'Tháng',
  'Year/s': 'Năm',
  'Hour/s': 'Giờ',
  'Minute/s': 'Phút',
  'Second/s': 'Giây',
  'Week/s': 'Tuần',
  'show': 'Hiển thị',
  noUploadToBlockchain: "Không tải lên Blockchain",
  noDataForBlockchain: "Vì không có báo cáo phá rừng nào được tạo ra cho các địa điểm sản xuất, nên không có dữ liệu để ghi vào blockchain. Nếu điều này là bất ngờ, vui lòng đảm bảo rằng các báo cáo cho các trang trại đã được tạo đúng cách trong các bước trước.",
  pleaseAgreeToDeclaration: "Vui lòng đồng ý với tuyên bố để kết thúc.",
  importProductionPlaceTT: "Cho phép người dùng nhập dữ liệu địa điểm sản xuất bằng cách sử dụng các tùy chọn tải lên hoặc tải xuống tệp.",
  defaultCircularGeofence: "Các trang trại không có hàng rào địa lý hoặc không có thông tin về kích thước của chúng sẽ được gán một hàng rào địa lý hình tròn mặc định là 4 ha. Nếu kích thước trung bình của trang trại nhỏ hơn 4 ha, vui lòng thay đổi kích thước mặc định bằng cách nhấp vào nút 'Chỉnh sửa' bên dưới.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "Theo EUDR, các trang trại dưới 4 ha không cần đa giác.",
  uploadOneDeforestationAssessmentForAllFarms: "TẢI LÊN MỘT ĐÁNH GIÁ PHÁ RỪNG CHO TẤT CẢ CÁC TRANG TRẠI",
  uploadAssessment: "Tải Lên Đánh Giá"
}
